// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
////////////////////////////////
// Tiki Runner gameController //
////////////////////////////////

/* module manages the main game this inherits from spinFunctions */

function RNG() {
  const m = 0x80000000;
  const a = 1664525;
  const c = 1013904223;

  let state;

  this.seed = function (newSeed) {
    let seedToUse = newSeed;

    if (typeof newSeed === 'string') {
      let hash = 0;
      for (let i = 0; i < newSeed.length; i++) {
        hash = newSeed.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash;
      }
      seedToUse = Math.abs(hash);
    }
    state = seedToUse ? seedToUse : 0;
  };

  this.seed(0);

  this.nextInt = function () {
    state = (a * state + c) % m;
    return state;
  };

  this.nextFloat = function () {
    return this.nextInt() / (m - 1);
  };
}

gameController = (function () {
  var _payWinsEvent = {};
  var _poppingSymbols = [];
  var _dropEvent = [];
  var _groupWinAmount = 0;
  var _groupWinCount = 0;
  var _popAndDropCompleteEvent = 0;
  var _totalWinnings = 0;
  var _fullGameWinnings = 0;
  var _numberOfPops = 0;
  var _jackpotTask;
  var _currentTime;
  var _gameCompleteEvent;
  var _featureAwarded = false;
  var _animWinsFinished = false;
  var _recoveryTask;
  var _extraStopDistances = Utils.fillArray([], 0, Globals.NUM_REELS);
  var messageBox = undefined;
  var _skipWin = false;
  var _bonusSymbolsLanded = 0;
  var _initialDropping = 0;
  var _anticipationAnimsPlayed = 0;

  var _isPromotion = false;

  var _bigWin = undefined;

  var _inBuyABonus = false;

  var _wildBlastAnims = [];
  var _wildAwardAnims = [];
  var _playedWildBlastAnims = [];
  var _symbolDisappearAnims = [];
  var _landedAnimsPlaying = [];
  var _symbolCallbackFired = [];

  var _anticipationAnims = [];
  var _anticipationAnimsData = null;
  var _anticipationEffectLeft = null;
  var _anticipationEffectRight = null;

  var _multiplierDisplay = undefined;
  var _freeSpinsMeter = undefined;
  var _winMeterContainer = undefined;

  var _spinBonusSounds = ['bonusLand1', 'bonusLand2', 'bonusLand3', 'bonusLand4', 'bonusLand5'];
  var _bonusLandAnimsPlayed = -1;

  var clickSpinSounds = ['clickPlay1', 'clickPlay2', 'clickPlay3'];

  var _cascadeSounds = ['cascade1', 'cascade2', 'cascade3'];
  var _explodeSounds = ['explode1', 'explode2', 'explode3'];

  var loWinSounds = ['loWin1', 'loWin2', 'loWin3'];
  var hiWinSounds = ['hiWin1', 'hiWin2', 'hiWin3'];

  var _anticipationSounds = ['anticipation1', 'anticipation2', 'anticipation3'];

  var reelspinSound = undefined;
  var reelspinSoundFade = undefined;

  var localRNG = undefined;

  var _blockDistributionData = null;
  var _gigabloxFactory = null;

  var _goldenClawMoveReels = false;

  var _finalWinningsForWinCycle = 0;
  var _idleTimer = undefined;
  var _idleTimerPaused = false;
  var _showLastWinTimer = undefined;
  var _lastWinTween = undefined;

  // var _dropSymbolsGigaData = {};

  ///////////////////////////////////////////////////
  function resetWinnings() {
    _totalWinnings = 0;
    _numberOfPops = 0;
    _finalWinningsForWinCycle = 0;
  }

  ///////////////////////////////////////////////////
  function jackpotGame(task) {
    _jackpotTask = task;
    _jackpotTask.join();

    _bigWin.start(task.data.value, function () {
      _jackpotTask.leave();
    });
  }

  ///////////////////////////////////////////////////
  function recoverGame(task) {
    // Recovery game with encore
    if (task.data.metaData === 'encore' && gameData.encoreEnabled !== task.data.metaValue) {
      // Clear any encore effects and stop them appearing again
      gameData.encoreEnabled = task.data.metaValue;

      // Put button in the right state if not already true
      var encoreButtonLB = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');

      if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }
    }

    resourceManager.get('helpScrollContainer:helpPageScroll').close();

    if (task.data.metaData === 'buyABonus' && task.data.metaValue) {
      _inBuyABonus = true;
      gameController.inBuyABonus = true;

      let baseStake = gameData.recoveryStake;

      let stakeController = resourceManager.getController('stakeController');

      let stakes = stakeController.Stakes;
      let returnStake = stakes.find((stake) => stake === baseStake);

      if (!returnStake) {
        returnStake = stakes[0];
      }

      gameData.stakeMeter.set(baseStake);

      stakeController.requestChangeStake(returnStake);
      stakeController.requestChangeStake(baseStake, 'BONUS_BUY');

      initNewSpin();
    } else {
      initNewSpin();

      // Update stake
      let stakeController = resourceManager.getController('stakeController');

      let baseStake = stakeController.BaseStake;
      let bpl = baseStake / 25; // appears unused
      let luckyBetEnabled = gameData.encoreEnabled;

      stakeController.setStakeMultiplier(luckyBetEnabled ? Globals.GB_MULTIPLIER : 1);
      game.changeStake(baseStake * (luckyBetEnabled ? Globals.GB_MULTIPLIER : 1), bpl);
      stakeController.broadcastCurrentStake();
    }
  }

  ///////////////////////////////////////////////////
  function onPromotionStarted() {
    _isPromotion = true;
  }

  ///////////////////////////////////////////////////
  function onPromotionEnded() {
    _isPromotion = false;
  }

  ///////////////////////////////////////////////////
  function initNewSpin() {
    // Start of new game
    gameController._receivedResponse = false;
    console.log('gameController.REELS_SPINNING - gameController._receivedResponse = false');

    gameController.resetWinnings();

    _bonusSymbolsLanded = 0;
    _bonusLandAnimsPlayed = -1;
    _anticipationAnimsPlayed = -1;
    gameController.firstLongSpinReelId = undefined;
    gameController.lastLongSpinReelId = undefined;

    //encoreEffect.reelSpinStarted();

    musicManager.onGameStart();

    resourceManager.get('buttonContainer:buttonBar:spinButton').visible = false;

    gameController.reelsSpinning = true;
    console.log('spinFunctions:onSpinComplete - gameController.reelsSpinning = true;');

    _winMeterContainer.visible = false;
    gameData.winningsMeter.set(0);

    resourceManager.get('gameLogo').playAnimation();

    var config = resourceManager.get('slotContainer').Props.configValues;

    gameData.reels.forEach(function (value) {
      value.setSpinParameters({
        spinSpeed: config.spinSpeed,
        landOffset: config.landOffset,
        decelerationDistance: config.decelerationDistance,
      });
    });

    _payWinsEvent = undefined;

    gameController.spinTask = undefined;

    symbolGlowManager.cancelAllGlows();

    gameController.slamStopped = false;
    // can this go into gigabloxFactory?
    gameController.cleanUpAboveSymbolsBeforeSpin();
    _gigabloxFactory.infiniteSpin();

    //		slotMachine.clearReels();
    gameController.resetSymbolCallbackFired();

    // this needs to go to an intermediate state until the drop is finished - then into reels_spinning
    console.log("GameController.switchState('REELS_SPINNING')");
    gameController.stateMachine.switchState('REELS_SPINNING');

    // Update autoplay button text
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining > 0 ? String(spinsRemaining - 1) : '∞';

    resourceManager.getController('inputOverlord').setText('autoplayCancelButton', spinsRemainingStr);
  }

  function startGame() {
    _gigabloxFactory.disableSymbolHitAreas();

    messageBus.postImmediate('gameController:startGame');

    let autoplay = resourceManager.get('autoplayContainer:autoplayBacker');
    if (autoplay.visible) return;

    let buyBonusPopUp = resourceManager.get('buyABonusContainer:buyBonusPopup');
    if (buyBonusPopUp.visible) return;

    if (!autoplayManager.isAutoplayEnabled()) {
      soundManager.play(clickSpinSounds[Math.floor(Math.random() * clickSpinSounds.length)]);
    }

    initNewSpin();
    var stakeController = resourceManager.getController('stakeController');
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;
    _inBuyABonus = false;

    gdk.startGame(
      {
        //numbers should came from the stake controller
        stake: stakeController.CurrentStake,
        numWinlines: stakeController.CurrentWinLineCount,
        bpl: bpl,
        metaData: {
          encore: gameData.encoreEnabled,
          buyABonus: false,
        },
      },
      function () {
        gdk.getNextGameOutcome(function () {});
      }
    );
  }

  function setBonusFlag(flag) {
    _inBuyABonus = flag;
  }

  ///////////////////////////////////////////////////
  function onAbortGame() {
    _gigabloxFactory.abortSpin();

    console.log("GameController.switchState('WAITING_FOR_SERVER')");
    gameController.stateMachine.switchState('WAITING_FOR_SERVER');
    resourceManager.get('buttonContainer:buttonBar:spinButton').visible = true;
    soundManager.stop('reelspinSound');
  }

  ///////////////////////////////////////////////////
  function doPayWins(payWinsEvent) {
    _payWinsEvent = payWinsEvent;
    _payWinsEvent.join();
    _numberOfPops++;

    console.log(`doPayWins - winCapped = ${_payWinsEvent.data.winCapped}`);

    /// TODO SA Win levels may need tweaking
    if (!freespins.inFreespins /*!freespins.areFreeSpinsActive()*/) {
      if (_numberOfPops >= 2) {
        musicManager.tempFadeLevels(
          musicManager.MULTIWINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
      } else if (_numberOfPops === 1) {
        musicManager.tempFadeLevels(
          musicManager.SINGLEWINLEVEL,
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut
        );
      }
    } else {
      // we do this once all cascades have finished on this spin
      //musicManager.freeSpinsNextLevel();
    }

    // Add to cumulative total winnings
    _skipWin = false;
    _totalWinnings += _payWinsEvent.data.totalLineWinnings;
    _fullGameWinnings += _payWinsEvent.data.totalLineWinnings;

    // gameController.canCelebrate = _totalWinnings > resourceManager.getController('stakeController').CurrentStake;
    gameController.canCelebrate =
      _payWinsEvent.data.totalLineWinnings > resourceManager.getController('stakeController').CurrentStake;

    // gameController.playWinningsSounds(_totalWinnings, resourceManager.getController('stakeController').CurrentStake);
    // gameController.playWinningsSounds(
    //   _payWinsEvent.data.totalLineWinnings,
    //   resourceManager.getController('stakeController').CurrentStake
    // );

    _extraSpinsFlyingToTotem = 0;

    console.log("GameController.switchState('PAYWINS')");
    gameController.stateMachine.switchState('PAYWINS');
  }

  ///////////////////////////////////////////////////
  function preGameComplete(gameCompleteEvent) {
    doGameComplete(gameCompleteEvent);
  }

  ///////////////////////////////////////////////////
  function doGameComplete(gameCompleteEvent) {
    resourceManager.get('buttonContainer:buttonBar:spinButton').visible = true;
    // gameData.creditMeter.set(gameData.credit + _fullGameWinnings);

    if (_inBuyABonus) {
      // restore the original stake
      let stakeController = resourceManager.getController('stakeController');
      stakeController.broadcastCurrentStake('default');
    }

    _inBuyABonus = false;

    if (_multiplierDisplay.isMultiplierActive()) {
      // We need to close the lantern door
      _multiplierDisplay.closeDoor();
    }

    excitementManager.clear();
    musicManager.onGameEnd();

    _fullGameWinnings = 0;
    // console.log(`_finalWinningsForWinCycle = ${gameCompleteEvent.data.totalWinnings}`, gameCompleteEvent.data);
    _finalWinningsForWinCycle = gameCompleteEvent.data.totalWinnings;
    console.log("GameController.switchState('END_GAME')");
    gameController.stateMachine.switchState('END_GAME');
  }

  ///////////////////////////////////////////////////
  function autoplayStarted(autoplayData) {
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining >= 0 ? String(spinsRemaining) : 'X';

    const autoplayCancelButton = resourceManager.get('buttonContainer:buttonBar:autoplayCancelButton');
    if (!autoplayCancelButton.button.textContainer) {
      autoplayCancelButton.button.textContainer = resourceManager.createObject(
        'container',
        'buttonTextContainer',
        autoplayCancelButton.button.name
      );
      autoplayCancelButton.button.textContainer.scale.set(0.5);
      autoplayCancelButton.button.textContainer.addChild(autoplayCancelButton.button.buttonText);
    }

    resourceManager.getController('inputOverlord').setText('autoplayCancelButton', spinsRemainingStr);
    // winlineManager.enableWinlinesTouch(false);
  }

  ///////////////////////////////////////////////////
  function autoplayEnded(autoplayData) {
    resourceManager.get('buttonContainer:buttonBar:autoplayButton:glow').visible = false;
    resourceManager.getController('inputOverlord').setText('autoplayCancelButton', '');
  }

  function onGameConfigEvent(event) {
    gameController.blockDistributionData = {
      blockDistribution: event.data.slotConfig.loadingBoard.blockDistribution,
      board: event.data.slotConfig.loadingBoard.board,
    };

    winlineAnimationController.paylines = event.data.slotConfig.paylines;
  }

  ///////////////////////////////////////////////////
  function onPopAndDropComplete(popAndDropCompleteEvent) {
    //  soundManager.stop("build");

    // hide sticky wilds after it's all done

    var stake = resourceManager.getController('stakeController').CurrentStake;
    _popAndDropCompleteEvent = popAndDropCompleteEvent;

    console.log(`onPopAndDropComplete - winCapped = ${_popAndDropCompleteEvent.data.winCapped}`);

    if (false) {
      // if (popAndDropCompleteEvent.data.winnings > (stake * 20) && !freespins.inFreespins) {
      _popAndDropCompleteEvent.join();
      _bigWin.start(
        _popAndDropCompleteEvent.data.winnings,
        function () {
          gameController.stateMachine.switchState('PAY_TO_WINNINGS');
        },
        300
      );
    } else if (popAndDropCompleteEvent.data.winnings > 0) {
      _popAndDropCompleteEvent.join();
      console.log("GameController.switchState('PAY_TO_WINNINGS')");
      gameController.stateMachine.switchState('PAY_TO_WINNINGS');
    } else {
      // Losing game
    }
  }

  ///////////////////////////////////////////////////
  function onDropEvent(dropEvent) {
    _dropEvent = dropEvent;
    _dropEvent.join();

    console.log(`onDropEvent - winCapped = ${_dropEvent.data.winCapped}`);

    // before we remove and drop
    // are we golden claw?
    // do we need to move the golden claw reels over?
    _goldenClawMoveReels = false;
    if (_dropEvent.data.kind === 4) {
      const goldenClawModifier = resourceManager.get('goldenClawModifier:goldenClawModifier');
      if (!goldenClawModifier.goldenClawReelAtEnd()) {
        _goldenClawMoveReels = true;
      }
    }

    if (_goldenClawMoveReels === true) {
      console.log("GameController.switchState('MOVE_GOLDEN_CLAW_REEL')");
      gameController.stateMachine.switchState('MOVE_GOLDEN_CLAW_REEL');
    } else {
      excitementManager.addExcitement();
      console.log("GameController.switchState('DROP_SYMBOLS')");
      gameController.stateMachine.switchState('DROP_SYMBOLS');
    }
  }

  ///////////////////////////////////////////////////
  // function onRespinIntro(event) {
  // 	let task = event;
  // 	task.join();
  // 	gameData.isEncoreSpin = true;

  // }

  ///////////////////////////////////////////////////
  function onExtraSpinsRemaining(event) {}

  ///////////////////////////////////////////////////
  function onFeatureAnnounced(task) {
    _featureAwarded = true;
  }

  ///////////////////////////////////////////////////
  function onFeatureEnded(task) {
    _featureAwarded = false;
  }

  ///////////////////////////////////////////////////
  function update(delta, time) {
    // Store time for wobble
    _currentTime = time;

    this.stateMachine.update();
  }

  ///////////////////////////////////////////////////
  function dimAllReels(dim) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, 0x666666);
    }
  }

  ///////////////////////////////////////////////////
  function wobbleSymbol(symbol, amount, reel) {
    var prog = (_currentTime % 1000) / 1000 - reel * 0.1;
    var pos = Math.sin(Math.PI * 2 * prog) * amount;
    // TODO - decide if we still need to do this.
    //  symbol.position.set(0,pos);
  }

  ///////////////////////////////////////////////////
  //define gameController
  gameController = Object.create(spinFunctions);
  Object.defineProperties(gameController, {
    startGame: { value: startGame },
    resetWinnings: { value: resetWinnings },
    setBonusFlag: { value: setBonusFlag },
    initNewSpin: { value: initNewSpin },
    totalWinnings: { value: _totalWinnings },
    symbolDisappearAnims: { value: _symbolDisappearAnims },
    doGameComplete: { value: doGameComplete },
    isFeatureAwarded: {
      get: function () {
        return _featureAwarded;
      },
    },
    dimAllReels: { value: dimAllReels },
    inBuyABonus: {
      get: function () {
        return _inBuyABonus;
      },
      set: function (value) {
        _inBuyABonus = value;
      },
    },
    blockDistributionData: {
      get: function () {
        return _blockDistributionData;
      },
      set: function (value) {
        _blockDistributionData = value;
      },
    },
    extraStopDistances: {
      get: function () {
        return _extraStopDistances;
      },
      set: function (value) {
        _extraStopDistances = value;
      },
    },
  });

  ///////////////////////////////////////////////////
  gameController.resetSymbolCallbackFired = function () {
    _symbolCallbackFired = [];
  };

  ///////////////////////////////////////////////////
  gameController.setupAnticipationAnims = function () {
    _anticipationAnims = [];

    let baseContainer = 'slotContainer:anticipationContainer';

    for (let i = 0; i < 4; i++) {
      let movie = resourceManager.get(baseContainer + ':anticipation' + i);
      movie.gotoAndStop(0);
      movie.visible = false;
      _anticipationAnims[i] = movie;
    }

    _anticipationAnimsData = {
      1: [
        [null, null], // reel 1
        [null, null], // reel 2
        [_anticipationAnims[0], _anticipationAnims[1]], // reel 3
        [_anticipationAnims[1], _anticipationAnims[2]], // reel 4
        [_anticipationAnims[2], _anticipationAnims[3]], // reel 5
      ],
      2: [
        [null, null], // reel 1
        [null, null], // reel 2
        [_anticipationAnims[0], _anticipationAnims[2]], // reel 3
        [_anticipationAnims[1], _anticipationAnims[3]], // reel 4
        [null, null], // reel 5 - not pos
      ],
      3: [
        [null, null], // reel 1 - not pos
        [null, null], // reel 2 - not pos
        [_anticipationAnims[0], _anticipationAnims[3]], // reel 3
        [null, null], // reel 4 - not pos
        [null, null], // reel 5 - not pos
      ],
    };
  };

  ///////////////////////////////////////////////////
  // gameController.startAnticipation = function (reel) {
  //   if (!gameController._anticipationActive) {
  //     timerManager.addTimer(
  //       700,
  //       function (progress) {
  //         soundManager.setMusicVolume(
  //           helper.linearInterpolate(soundManager.musicVolume, settingsMenu.sounds.musicPercent * 0.2, progress)
  //         );
  //       },
  //       function () {
  //         soundManager.setMusicVolume(settingsMenu.sounds.musicPercent * 0.2);
  //       }
  //     );
  //   }
  //   gameController._anticipationActive = true;

  //   // stop previous anim if it's playing/defined
  //   if (_anticipationAnims[reel - 1] !== undefined) {
  //     _anticipationAnims[reel - 1].visible = false;
  //     _anticipationAnims[reel - 1].gotoAndStop(0);
  //   }

  //   // play the next in sequence
  //   if (_anticipationAnims[reel] !== undefined) {
  //     _anticipationAnims[reel].visible = true;
  //     _anticipationAnims[reel].gotoAndPlay(0);
  //   }
  // };

  ///////////////////////////////////////////////////
  gameController.stopAnticipation = function (reel) {
    soundManager.stop('bigBlockAnticipation');
    for (let i = 0; i < _anticipationSounds.length; i++) {
      soundManager.stop(_anticipationSounds[i]);
    }
    // gameController._anticipationActive = false;
    // for (let i = 2; i < gameData.reels.length; i++) {
    //   _anticipationAnims[i].visible = false;
    //   _anticipationAnims[i].gotoAndStop(0);
    // }

    timerManager.addTimer(
      500,
      function (progress) {
        const volume = helper.linearInterpolate(
          { x: soundManager.musicVolume, y: 0 },
          { x: settingsMenu.sounds.musicPercent, y: 0 },
          progress
        ).x;
        soundManager.setMusicVolume(volume);
      },
      function () {
        soundManager.setMusicVolume(settingsMenu.sounds.musicPercent);
      }
    );
  };

  ///////////////////////////////////////////////////
  gameController.setupSymbolDisappearAnims = function () {
    const numReels = 5;
    const numRows = 5;
    const explosionWidth = 180;
    const explosionHeight = 180;

    const reelsParticleLayer = resourceManager.get('slotContainer:reelsParticleLayer');
    const mask = new PIXI.Graphics();
    mask.beginFill(0xff0000, 1);
    mask.drawRect(-10, 29, 700, 630);
    mask.endFill();
    reelsParticleLayer.addChild(mask);
    reelsParticleLayer.mask = mask;

    for (var i = 0; i < numReels; i++) {
      var rowAnims = [];

      for (var j = 0; j < numRows; j++) {
        const xPos = gameData.reels[i].position.getX() + explosionWidth / 2; // 170 is the width of the explosion sprite
        const yPos = gameData.reels[i].position.getY() + j * 126 + explosionHeight / 2;

        // let posX = (i + 1) * 170 + 10;
        // let posY = (j + 0.5) * 190 + 10;

        var movie = resourceManager.createObject(
          'movie',
          'symbolDisappear_' + i + '_' + j,
          'slotContainer:reelsParticleLayer',
          {
            definition: 'symbolFlash',
            x: xPos,
            y: yPos,
            anchor: 0.5,
            loop: false,
            scale: 0.5,
          }
        );
        movie.gotoAndStop(0);
        movie.visible = false;
        movie.origX = movie.x;
        movie.origY = movie.y;
        rowAnims.push(movie);
      }

      _symbolDisappearAnims.push(rowAnims);
    }
  };

  gameController.setupWildBlastAnims = function () {
    const numReels = 5;
    const numRows = 5;
    for (let i = 0; i < numReels; i++) {
      const rowAnims = [];

      for (let j = 0; j < numRows; j++) {
        const xPos = gameData.reels[i].position.getX();
        const yPos = gameData.reels[i].position.getY() + j * 126;

        const movie = resourceManager.createObject(
          'movie',
          'wildBlast_' + i + '_' + j,
          'slotContainer:wildBlastAnimContainer',
          {
            definition: 'wildBlast_md',
            x: xPos,
            y: yPos,
            anchor: 0.5,
            loop: false,
            scale: 1,
          }
        );
        movie.gotoAndStop(0);
        movie.origX = movie.x;
        movie.origY = movie.y;
        movie.origParent = movie.parent;
        movie.visible = false;
        movie.parent.removeChild(movie);
        rowAnims.push(movie);
      }

      _wildBlastAnims.push(rowAnims);
    }
  };

  gameController.setupWildAwardAnims = function () {
    const numReels = 5;
    const numRows = 5;

    for (let i = 0; i < numReels; i++) {
      const rowAnims = [];

      for (let j = 0; j < numRows; j++) {
        const xPos = gameData.reels[i].position.getX() + 90;
        const yPos = gameData.reels[i].position.getY() + j * 126 + 90;

        const movie = resourceManager.createObject(
          'movie',
          'wildAward_' + i + '_' + j,
          'slotContainer:reelsParticleLayer',
          {
            definition: 'Wild2x2_md',
            x: xPos,
            y: yPos,
            anchor: 0.5,
            loop: false,
            scale: 0.5,
          }
        );
        movie.gotoAndStop(0);
        movie.visible = false;
        rowAnims.push(movie);
        movie.origParent = movie.parent;
        movie.origX = movie.x;
        movie.origY = movie.y;
        movie.parent.removeChild(movie);
      }

      _wildAwardAnims.push(rowAnims);
    }
  };

  gameController._receivedResponse = false;
  gameController._anticipationActive = false;

  ///////////////////
  // State Machine //
  ///////////////////

  StateMachine.Create(gameController);

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('WAITING_FOR_SERVER', function () {});

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('WAIT_FOR_START', function () {
    if (gameController.phase.enter()) {
      // if we have had a win and we can celebrate it
      if (_finalWinningsForWinCycle > resourceManager.getController('stakeController').CurrentStake) {
        // start idle timer
        gameController.restartIdleTimer();
      }

      const gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
      gigabloxFactory.enableSymbolHitAreas();
    }

    if (gameController.phase.once()) {
      resourceManager.getController('autoplayController').checkLimits();
    }

    if (gameController.phase.hold()) {
      if (!resourceManager.getController('autoplayController').LimitPopupOpen) {
        gameController.phase.step();
        let gameLogo = resourceManager.get('gameLogo');
        if (!gameLogo.isPlaying) {
          gameLogo.playAnimationOnRepeat();
        }
      }
    }
    if (gameController.phase.hold()) {
      // Waiting for player to do something
      if (autoplayManager.isAutoplayEnabled()) {
        if (autoplayManager.AP.getFields()['numberOfRounds'].currentValue !== autoplayManager.AP.roundsRemaining()) {
          var timeToNext = 500;
          resourceManager.getController('autoplayController').timeToNextAutoplay = timeToNext;
          gameController.phase.step();
        }
      }
    }

    if (gameController.phase.timed(resourceManager.getController('autoplayController').timeToNextAutoplay)) {
      if (!autoplayManager.isAutoplayEnabled()) {
        gameController.phase.reset();
      }
    }
    if (gameController.phase.once()) {
      // if (!autoplayManager.isAutoplayEnabled()) {
      //   soundManager.play(clickSpinSounds[Math.floor(Math.random() * clickSpinSounds.length)]);
      // }
      // const gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
      // gigabloxFactory.disableSymbolHitAreas();
      startGame();
    }

    if (gameController.phase.exit()) {
      // stop idle timer
      gameController.killShowLastWin();
    }
  });

  ///////////////////////////////////////////////////
  // gameController.initialDropComplete = function (reelID) {
  //   --_initialDropping;
  // };

  ///////////////////////////////////////////////////
  // gameController.stateMachine.addState('CLEAR_REELS', function () {
  //   // when reels have cleared we can drop in new positions
  //   // clear reels has a callback to reduce reelsDropping count
  //   if (gameController.phase.enter()) {
  //     _initialDropping = gameData.reels.length;
  //   }

  //   // TODO 23/05/22 this needs to hold until all initial reels are dropped AND the spin task has been received
  //   if (gameController.phase.hold()) {
  //     if (_initialDropping === 0) {
  //       gameController.phase.step();
  //     }
  //   }

  //   // drop intial symbols needs to have finished before we do spin task leave and the symbols should all have landed
  //   if (gameController.phase.once()) {
  //     //gameController.stateMachine.switchState("REELS_SPINNING");
  //     console.log("GameController.switchState('DROP_INITIAL_SYMBOLS')");
  //     gameController.stateMachine.switchState('DROP_INITIAL_SYMBOLS');
  //   }
  // });

  ///////////////////////////////////////////////////
  // gameController.stateMachine.addState('DROP_INITIAL_SYMBOLS', function () {
  //   if (gameController.phase.hold()) {
  //     // don't proceed unless we receive the spin task
  //     if (gameController.spinTask !== undefined) {
  //       gameController.phase.step();
  //     }
  //   }

  //   if (gameController.phase.once()) {
  //     //gameController._receivedResponse = true;	// this allows slam stop

  //     _reelsSpinning = [true, true, true, true, true];
  //     _symbolCallbackFired = [];

  //     let _positions = gameController.spinTask.data.resultPanel.reelList.map(function (reel, index) {
  //       return reel.symbols.map(function (curr) {
  //         return curr.value;
  //       });
  //     });

  //     // we need to have a random symbol as the first below which we can drop
  //     // off the symbol grid when new symbols all cascade in
  //     let randomBelow = [];
  //     let allowedSymbols = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  //     for (var i = 0; i < gameData.reels.length; i++) {
  //       randomBelow[i] = allowedSymbols[getRandom(allowedSymbols.length)];
  //     }

  //     let _symbolsAbove = [[0], [0], [0], [0], [0]];
  //     let _symbolsBelow = [[randomBelow[0]], [randomBelow[1]], [randomBelow[2]], [randomBelow[3]], [randomBelow[4]]];

  //     // calculate whether we display landing symbols
  //     gameController.calcLandingAnims();

  //     // now drop the symbols in
  //     slotMachine.dropInitialSymbols(_symbolsAbove, _positions, _symbolsBelow);
  //   }

  //   if (gameController.phase.once()) {
  //     gameController._receivedResponse = true; // this allows slam stop
  //   }

  //   // don't proceed until all reels have finished spinning
  //   if (gameController.phase.hold()) {
  //     // check for any reels still spinning
  //     var spinComplete = true;
  //     for (var spinningIdx = 0; spinningIdx < _reelsSpinning.length; spinningIdx++) {
  //       spinComplete = spinComplete && !_reelsSpinning[spinningIdx];
  //     }

  //     if (spinComplete) {
  //       gameController.phase.step();
  //       gameController._receivedResponse = false;
  //     }
  //   }

  //   // wait for all landing anims to finish playing
  //   if (gameController.phase.hold()) {
  //     let anyPlaying = false;
  //     for (var i = 0; i < _landedAnimsPlaying.length; i++) {
  //       let reelID = _landedAnimsPlaying[i][0];
  //       let row = _landedAnimsPlaying[i][1];

  //       let animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
  //       if (animStrip.isAnimationPlaying(row)) {
  //         anyPlaying = true;
  //       }
  //     }

  //     // all landing anims finished - hide them away
  //     if (!anyPlaying) {
  //       for (var i = 0; i < _landedAnimsPlaying.length; i++) {
  //         let reelID = _landedAnimsPlaying[i][0];
  //         let row = _landedAnimsPlaying[i][1];

  //         let animStrip = resourceManager.get(reelManager.reels[reelID].linkedAnimations[0].name);
  //         animStrip.hideAnimation(row);
  //       }

  //       gameController.phase.step();
  //     }
  //   }

  //   if (gameController.phase.once()) {
  //     messageBox.clearMessage();
  //     gameData.creditMeter.set(gameData.credit + _totalWinnings);

  //     console.log("GameController.switchState('WAITING_FOR_SERVER')");
  //     gameController.stateMachine.switchState('WAITING_FOR_SERVER');

  //     if (gameController.spinTask) {
  //       gameController.spinTask.leave();
  //     }
  //   }
  // });

  ///////////////////////////////////////////////////
  // handle the anims on landing - cascadeInfiniReels calls this callback
  // then we match up if it's a valid bonus symbol to play anim/sound
  gameController.onSymbolLandedCallback = function (landedReel, landedRow) {
    /*
    var bonusLanded = false;

    // check that we have't already fired this callback ( can be retriggered doing a slam stop )
    for (var i = 0; i < _symbolCallbackFired.length; i++) {
      var firedReel = _symbolCallbackFired[i][0];
      var firedRow = _symbolCallbackFired[i][1];

      // if we've already fired this callback don't do it again
      if (landedReel === firedReel && landedRow === firedRow) {
        return;
      }
    }

    // we've got here so this must be the first time we've fired this callback - add to array
    _symbolCallbackFired.push([landedReel, landedRow]);

    // play landing anims as required
    // this wont be being called anymore
    for (var i = 0; i < _landedAnimsPlaying.length; i++) {
      var reel = _landedAnimsPlaying[i].reelIndex;
      var row = _landedAnimsPlaying[i].rowIndex;

      if (landedReel === reel && landedRow === row) {
        soundManager.play(_spinBonusSounds[reel]);

        var animStrip = resourceManager.get(reelManager.reels[reel].linkedAnimations[0].name);
        animStrip.playAnimation(landedRow, 'BonusLand');

        bonusLanded = true;
      }
    }

    // if we didn't play a sound on landing play it here - might need a different sound
    // don't play it on slam stop else the sounds all clash together
    // if ( !bonusLanded && !slotMachine.slamStopRequested ) {
    // 	soundManager.play( "symbolLand" );
    // }
    */
  };

  gameController.onSpinLand = function (reelIDStr) {
    const reelID = +reelIDStr[4]; // ick

    const layout = Utils.convertBlockDistributionToGigabloxLayout(
      gameController.blockDistributionData.blockDistribution
    );
    const reelWidth = layout[reelID].length;

    /* Anticipation
    █████╗ ███╗   ██╗████████╗██╗ ██████╗██╗██████╗  █████╗ ████████╗██╗ ██████╗ ███╗   ██╗
    ██╔══██╗████╗  ██║╚══██╔══╝██║██╔════╝██║██╔══██╗██╔══██╗╚══██╔══╝██║██╔═══██╗████╗  ██║
    ███████║██╔██╗ ██║   ██║   ██║██║     ██║██████╔╝███████║   ██║   ██║██║   ██║██╔██╗ ██║
    ██╔══██║██║╚██╗██║   ██║   ██║██║     ██║██╔═══╝ ██╔══██║   ██║   ██║██║   ██║██║╚██╗██║
    ██║  ██║██║ ╚████║   ██║   ██║╚██████╗██║██║     ██║  ██║   ██║   ██║╚██████╔╝██║ ╚████║
    ╚═╝  ╚═╝╚═╝  ╚═══╝   ╚═╝   ╚═╝ ╚═════╝╚═╝╚═╝     ╚═╝  ╚═╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝
    */

    gameController.stopLongSpinAnimation();

    if (reelID === layout.length - 1 && gameController._anticipationActive === true) {
      // last reel to stop
      timerManager.addTimer(
        500,
        function (progress) {
          const volume = helper.linearInterpolate(
            { x: soundManager.musicVolume, y: 0 },
            { x: settingsMenu.sounds.musicPercent, y: 0 },
            progress
          ).x;
          // console.log('fade music to ' + volume);
          soundManager.setMusicVolume(volume);
        },
        function () {
          soundManager.setMusicVolume(settingsMenu.sounds.musicPercent);
        }
      );
    }

    if (gameController.longSpinReason === 'BIG_BLOCK_WINS' || gameController.longSpinReason === 'BONUS') {
      if (
        (gameController.lastLongSpinReelId === -1 || gameController.lastLongSpinReelId > reelID + 1) &&
        !gameController.slamStopped
      ) {
        if (
          reelID < layout.length - 1 &&
          gameController.firstLongSpinReelId !== undefined &&
          reelID >= gameController.firstLongSpinReelId - 1
        ) {
          if (!gameController._anticipationActive) {
            timerManager.addTimer(
              500,
              function (progress) {
                const volume = helper.linearInterpolate(
                  { x: soundManager.musicVolume, y: 0 },
                  { x: settingsMenu.sounds.musicPercent * 0.6, y: 0 },
                  progress
                ).x;
                // console.log('fade music to ' + volume);
                soundManager.setMusicVolume(volume);
              },
              function () {
                soundManager.setMusicVolume(settingsMenu.sounds.musicPercent * 0.6);
              }
            );
          }
          gameController._anticipationActive = true;
          if (gameController.longSpinReason === 'BIG_BLOCK_WINS') {
            soundManager.play('bigBlockAnticipation');
          } else {
            _anticipationAnimsPlayed++;
            soundManager.play(_anticipationSounds[_anticipationAnimsPlayed]);
          }
          messageBus.postImmediate('spinner:AnticipationSpin', {});
          const trueReelIndex = Utils.gigaReelIndexToReelIndex(
            reelID + 1,
            gameController.blockDistributionData.blockDistribution
          );
          gameController.playLongSpinParticles(trueReelIndex, layout[reelID + 1].length);
        }
      }
    }

    /* Land anims
    ██╗      █████╗ ███╗   ██╗██████╗      █████╗ ███╗   ██╗██╗███╗   ███╗███████╗
    ██║     ██╔══██╗████╗  ██║██╔══██╗    ██╔══██╗████╗  ██║██║████╗ ████║██╔════╝
    ██║     ███████║██╔██╗ ██║██║  ██║    ███████║██╔██╗ ██║██║██╔████╔██║███████╗
    ██║     ██╔══██║██║╚██╗██║██║  ██║    ██╔══██║██║╚██╗██║██║██║╚██╔╝██║╚════██║
    ███████╗██║  ██║██║ ╚████║██████╔╝    ██║  ██║██║ ╚████║██║██║ ╚═╝ ██║███████║
    ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═════╝     ╚═╝  ╚═╝╚═╝  ╚═══╝╚═╝╚═╝     ╚═╝╚══════╝
    */

    const symbolsCfg = resourceManager.getConfiguration().symbols;
    const bonusID = symbolsCfg['Bonus'].ID;
    if (!freespins.inFreespins && !gameController.slamStopped) {
      // scatters are only in the base
      let symbolsOnReel = _gigabloxFactory.getSymbolsOnReel(reelID);
      symbolsOnReel = symbolsOnReel.slice(0, 5); // in base the window is only 5 high, ignore post and pre app symbols
      // needed for the original 5 reels
      const trueReelIndex = Utils.gigaReelIndexToReelIndex(
        reelID,
        gameController.blockDistributionData.blockDistribution
      );
      for (let row = 0; row < symbolsOnReel.length; row++) {
        if (symbolsOnReel[row] === bonusID) {
          for (let w = 0; w < reelWidth; w++) {
            for (let l = 0; l < _landedAnimsPlaying[trueReelIndex + w].length; l++) {
              if (_landedAnimsPlaying[trueReelIndex + w][l].rowIndex === row) {
                const animStrip = resourceManager.get(reelManager.reels[trueReelIndex + w].linkedAnimations[0].name);
                animStrip.playAnimation(row, 'BonusLand');
                _bonusLandAnimsPlayed++;
              }
            }
          }
          soundManager.play(_spinBonusSounds[_bonusLandAnimsPlayed]);
        }
      }
    }
  };

  gameController.onSpinHit = function (reelIDStr) {
    const reelID = +reelIDStr[4]; // ick
    console.log(`gameController.onSpinHit ${reelIDStr} - ${reelID}`);

    // Reel landing sound depends on width of reels
    const layout = Utils.convertBlockDistributionToGigabloxLayout(
      gameController.blockDistributionData.blockDistribution
    );
    console.log(`gameController.onSpinHit layout`, layout, gameController.blockDistributionData.blockDistribution);
    const reelWidth = layout[reelID].length;

    /* land sounds
    ██╗      █████╗ ███╗   ██╗██████╗     ███████╗ ██████╗ ██╗   ██╗███╗   ██╗██████╗ ███████╗
    ██║     ██╔══██╗████╗  ██║██╔══██╗    ██╔════╝██╔═══██╗██║   ██║████╗  ██║██╔══██╗██╔════╝
    ██║     ███████║██╔██╗ ██║██║  ██║    ███████╗██║   ██║██║   ██║██╔██╗ ██║██║  ██║███████╗
    ██║     ██╔══██║██║╚██╗██║██║  ██║    ╚════██║██║   ██║██║   ██║██║╚██╗██║██║  ██║╚════██║
    ███████╗██║  ██║██║ ╚████║██████╔╝    ███████║╚██████╔╝╚██████╔╝██║ ╚████║██████╔╝███████║
    ╚══════╝╚═╝  ╚═╝╚═╝  ╚═══╝╚═════╝     ╚══════╝ ╚═════╝  ╚═════╝ ╚═╝  ╚═══╝╚═════╝ ╚══════╝
    */

    let landSound = undefined;
    let sndIdx = -1;
    const landSoundWidth1 = ['symbolLand1', 'symbolLand2', 'symbolLand3', 'symbolLand4', 'symbolLand5'];
    // const landSoundWidth2 = ['symbolLandBig'];
    switch (reelWidth) {
      case 1:
        sndIdx = reelID; //Math.floor(Math.random() * landSoundWidth1.length);
        landSound = landSoundWidth1[sndIdx];
        break;
      // sndIdx = Math.floor(Math.random() * landSoundWidth2.length);
      // landSound = landSoundWidth2[sndIdx];
      // break;
      case 2:
      case 3:
        landSound = 'symbolLandBig';
        break;
      default:
        break;
    }
    if (landSound !== undefined) {
      soundManager.play(landSound);
    }

    /* shake on 3x3
    ███████╗██╗  ██╗ █████╗ ██╗  ██╗███████╗     ██████╗ ███╗   ██╗    ██████╗ ██╗  ██╗██████╗ 
    ██╔════╝██║  ██║██╔══██╗██║ ██╔╝██╔════╝    ██╔═══██╗████╗  ██║    ╚════██╗╚██╗██╔╝╚════██╗
    ███████╗███████║███████║█████╔╝ █████╗      ██║   ██║██╔██╗ ██║     █████╔╝ ╚███╔╝  █████╔╝
    ╚════██║██╔══██║██╔══██║██╔═██╗ ██╔══╝      ██║   ██║██║╚██╗██║     ╚═══██╗ ██╔██╗  ╚═══██╗
    ███████║██║  ██║██║  ██║██║  ██╗███████╗    ╚██████╔╝██║ ╚████║    ██████╔╝██╔╝ ██╗██████╔╝
    ╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝     ╚═════╝ ╚═╝  ╚═══╝    ╚═════╝ ╚═╝  ╚═╝╚═════╝ 
    */

    let isDouble3x3 = false; // gameController.spinTask.data.linkedReels.length === 2 && gameController.spinTask.data.linkedReels[0].length === 3;
    if ((isDouble3x3 && reelID === 1) || (!isDouble3x3 && reelWidth >= 3)) {
      const screenShaker = resourceManager.get('screenShaker');
      //soundManager.play("reel_stop");
      if (screenShaker.isShaking()) {
        screenShaker.stop();
        // gameController.leprechaunAnim.onIdle();
      }
      if (soundManager.isSoundPlaying('Rumble_Loop')) {
        soundManager.stop('Rumble_Loop');
        //let sfxId = soundManager.play("Hard_Hit");
        //gameController.setRumbleVolume(reelWidth, sfxId)
        gameController.sfxRumbleId = -1;
      }
      screenShaker.blockLanded(reelWidth);
      // particleManager.createEmitter('symbol_land', 'reelBorderContainer:reelBorderBottom', 0, 0, true);
    } else {
      //soundManager.play("reel_stop_small");
    }
  };

  gameController.anyLandAnimsStillPlaying = function () {
    let result = false;

    if (Utils.isArray(_landedAnimsPlaying)) {
      for (let reel = 0; reel < _landedAnimsPlaying.length; reel++) {
        for (let i = 0; i < _landedAnimsPlaying[reel].length; i++) {
          const row = _landedAnimsPlaying[reel][i].rowIndex;
          const animStrip = resourceManager.get(reelManager.reels[reel].linkedAnimations[0].name);
          if (animStrip.isAnimationPlaying(row)) {
            result = true;
          }
        }
      }
    }

    return result;
  };

  gameController.hideLandingAnims = function () {
    if (Utils.isArray(_landedAnimsPlaying)) {
      for (let reel = 0; reel < _landedAnimsPlaying.length; reel++) {
        for (let i = 0; i < _landedAnimsPlaying[reel].length; i++) {
          const row = _landedAnimsPlaying[reel][i].rowIndex;
          const animStrip = resourceManager.get(reelManager.reels[reel].linkedAnimations[0].name);
          animStrip.hideAnimation(row);
        }
      }
    }
  };

  gameController.playScatterWinAnimations = function () {
    const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
    const layout = Utils.convertBlockDistributionToGigabloxLayout(
      gameController.blockDistributionData.blockDistribution
    );
    const reels = _gigabloxFactory.getReelVisuals();
    let reelIndex = 0;
    for (let reelID = 0; reelID < reels.length; reelID++) {
      const reelWidth = layout[reelID].length;
      let symbolsOnReel = _gigabloxFactory.getSymbolsOnReel(reelID);
      symbolsOnReel = symbolsOnReel.slice(0, 5); // in base the window is only 5 high, ignore post and pre app symbols
      for (let row = 0; row < symbolsOnReel.length; row++) {
        if (symbolsOnReel[row] === bonusID) {
          for (let w = 0; w < reelWidth; w++) {
            const animStrip = resourceManager.get(reelManager.reels[reelIndex + w].linkedAnimations[0].name);
            animStrip.playAnimation(row, 'BonusWin');
          }
        }
      }
      reelIndex += reelWidth;
    }
  };

  gameController.anyScatterWinAnimsStillPlaying = function () {
    // tbh it just looks for any anims playing
    const layout = Utils.convertBlockDistributionToGigabloxLayout(
      gameController.blockDistributionData.blockDistribution
    );
    let result = false;
    const reels = _gigabloxFactory.getReelVisuals();
    let reelIndex = 0;
    for (let reelID = 0; reelID < reels.length; reelID++) {
      const reelWidth = layout[reelID].length;
      for (let row = 0; row < Globals.NUM_ROWS; row++) {
        for (let w = 0; w < reelWidth; w++) {
          const animStrip = resourceManager.get(reelManager.reels[reelIndex + w].linkedAnimations[0].name);
          if (animStrip.isAnimationPlaying(row)) {
            result = true;
          }
        }
      }
      reelIndex += reelWidth;
    }
    return result;
  };

  gameController.hideScatterWinAnimsStillPlaying = function () {
    // tbh it just looks for any anims playing
    const layout = Utils.convertBlockDistributionToGigabloxLayout(
      gameController.blockDistributionData.blockDistribution
    );
    let result = false;
    const reels = _gigabloxFactory.getReelVisuals();
    let reelIndex = 0;
    for (let reelID = 0; reelID < reels.length; reelID++) {
      const reelWidth = layout[reelID].length;
      for (let row = 0; row < Globals.NUM_ROWS; row++) {
        for (let w = 0; w < reelWidth; w++) {
          const animStrip = resourceManager.get(reelManager.reels[reelIndex + w].linkedAnimations[0].name);
          animStrip.hideAnimation(row);
        }
      }
      reelIndex += reelWidth;
    }
    return result;
  };

  gameController.stopLongSpinAnimation = function () {
    // soundManager.stop("Anticipation");
    if (_anticipationEffectLeft) {
      _anticipationEffectLeft.gotoAndStop(0);
      _anticipationEffectLeft.visible = false;
      _anticipationEffectLeft = null;
    }
    if (_anticipationEffectRight) {
      _anticipationEffectRight.gotoAndStop(0);
      _anticipationEffectRight.visible = false;
      _anticipationEffectRight = null;
    }
    // gameController.gigabloxTransitionParticles.forEach(function(particle){
    //     particle.particleEmitter.emit = false;
    //     particle.visible = false;
    // });
  };

  gameController.playLongSpinParticles = function (realReel, blockSize) {
    _anticipationEffectLeft = _anticipationAnimsData[blockSize][realReel][0];
    _anticipationEffectRight = _anticipationAnimsData[blockSize][realReel][1];
    if (_anticipationEffectLeft) {
      _anticipationEffectLeft.visible = true;
      _anticipationEffectLeft.gotoAndPlay(0);
    }
    if (_anticipationEffectRight) {
      _anticipationEffectRight.visible = true;
      _anticipationEffectRight.gotoAndPlay(0);
    }

    // const symbolWidth = 140 * gameController.gigabloxFactory._activeSlotMachine.parent.scale.x;
    // const symbolHeight = 140 * gameController.gigabloxFactory._activeSlotMachine.parent.scale.y;
    // const height = gameController.numberOfActiveRows * symbolHeight + 150;
    // const x = gameController.gigabloxFactory._activeSlotMachine.parent.position.x  + (realReel * symbolWidth);
    // const x2 = x + (blockSize * symbolWidth);
    // let extraRows = (gameController.numberOfActiveRows - 4);
    // const y = layoutController.getCurrentLayoutProperties().landscape ? layoutController.getCurrentPosition(gameController.gigabloxTransitionParticles[0].BPprops.FQN).y :
    //     layoutController.getCurrentPosition(gameController.gigabloxTransitionParticles[0].BPprops.FQN).y - ((symbolHeight * extraRows) / 2) + (extraRows * 25);
    // gameController.gigabloxTransitionParticles[0].position.setY(y);
    // gameController.gigabloxTransitionParticles[1].position.setY(y);
    // gameController.gigabloxTransitionParticles[0].position.setX(x);
    // gameController.gigabloxTransitionParticles[1].position.setX(x2);
    // gameController.gigabloxTransitionParticles[0].BPprops.landscape_default.position.x = x;
    // gameController.gigabloxTransitionParticles[1].BPprops.landscape_default.position.x = x2;
    // gameController.gigabloxTransitionParticles[0].BPprops.portrait_default.position.x = x;
    // gameController.gigabloxTransitionParticles[1].BPprops.portrait_default.position.x = x2;
    // gameController.gigabloxTransitionParticles[0].particleEmitter.spawnRect.height = height;
    // gameController.gigabloxTransitionParticles[1].particleEmitter.spawnRect.height = height;
    // for(let i = 0; i < 2; ++i) {
    //     gameController.gigabloxTransitionParticles[i].particleEmitter.emit = true;
    //     gameController.gigabloxTransitionParticles[i].visible = true;
    // }
  };

  ///////////////////////////////////////////////////
  gameController.calcLandingAnims = function () {
    gameController.extraStopDistances = Utils.fillArray([], 0, Globals.NUM_REELS);
    const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
    const numReels = reelManager.reels.length;
    const numRows = 5;
    const resultPanel = gameController.spinTask.data.resultPanel;
    const reelLists = resultPanel.reelList;
    // reset before recalculating
    _landedAnimsPlaying = [];
    _bonusSymbolsLanded = 0;
    // this assumes we only get one bonus symbol visible per reel
    for (let reelID = 0; reelID < numReels; reelID++) {
      _landedAnimsPlaying[reelID] = [];
      const symbols = reelLists[reelID].symbols;
      let found = false;
      let foundRow = -1;
      for (let i = 0; i < numRows; i++) {
        if (symbols[i].value === bonusID) {
          found = true;
          foundRow = i;
        }
      }
      // only play the sound/anim if it's possible to activate enough bonus symbols
      if (found) {
        if (_bonusSymbolsLanded >= reelID - 2) {
          // save reel/row
          _landedAnimsPlaying[reelID].push({ reelIndex: reelID, rowIndex: foundRow });
          gameController.extraStopDistances[reelID] = 20;
        }
        _bonusSymbolsLanded++;
      }
    }
  };

  ///////////////////////////////////////////////////
  // when reel has landed all symbols - mark as no longer spinning
  // gameController.onSpinCompleteBase = function(reelID) {
  // 	_reelsSpinning[reelID] = false;
  // };

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('REELS_SPINNING', function () {
    if (gameController.phase.enter()) {
      gameController.reelsSpinning = true;
      //_reelsSpinning = gameData.reels.length; // [ true, true, true, true, true ];
      reelspinSound = soundManager.play('reelspinSound');
      if (reelspinSound) {
        if (reelspinSoundFade) {
          reelspinSoundFade.kill();
          reelspinSoundFade = undefined;
        }
        soundManager.setVolume(1, reelspinSound);
      }
    }

    if (gameController.phase.hold()) {
      if (gameController.spinTask !== undefined) {
        // calculate whether we display landing symbols
        gameController.blockDistributionData = {
          blockDistribution: gameController.spinTask.data.blockDistribution,
          board: gameController.spinTask.data.lastRespin.payBoard,
        };
        console.log(
          'gameController.REELS_SPINNING - saving block distribution',
          gameController.blockDistributionData.blockDistribution
        );

        gameController._receivedResponse = true; // this allows slam stop
        console.log('gameController.REELS_SPINNING - gameController._receivedResponse = true');

        // this is now called before the reels are asked to stop
        // gameController.calcLandingAnims();
        gameController.phase.step();
      }
    }

    // wait for spin to complete - this has to be before the land anims check
    if (gameController.phase.hold()) {
      if (gameController.reelsSpinning === false) {
        if (reelspinSound) {
          reelspinSoundFade = gsap.to(this, {
            duration: 0.4,
            onUpdate: () => {
              soundManager.setVolume(1 - reelspinSoundFade.progress(), reelspinSound);
            },
            onComplete: () => {
              soundManager.stop('reelspinSound');
            },
          });
        }

        gameController.phase.step();
      }
    }

    // wait for all landing anims to finish playing
    if (gameController.phase.hold()) {
      if (gameController.anyLandAnimsStillPlaying() === false) {
        gameController.hideLandingAnims();
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log("GameController.switchState('WAITING_FOR_SERVER')");
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');
    }

    if (gameController.phase.exit()) {
      messageBox.clearMessage();

      // If the game has aborted the spin task will be undefined
      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('PAYWINS', function () {
    if (gameController.phase.once()) {
      // whats the biggest sized win?
      // do we have a 5oak?
      if (gameController.canCelebrate) {
        let fiveOAKWinAnimRequired = false;
        const winningLines = _payWinsEvent.data.winningLines;
        for (let i = 0; i < winningLines.length; i++) {
          if (winningLines[i].positions.length > 4) {
            fiveOAKWinAnimRequired = true;
            break;
          }
        }

        if (fiveOAKWinAnimRequired === true) {
          _fiveOAK.show();
        }
      }
    }

    if (gameController.phase.hold()) {
      if (_fiveOAK.isActive() !== true) {
        // either we havent had a 5oak or the anim has finished
        gameController.phase.step();
      }
    }

    // show winning symbols
    if (gameController.phase.once()) {
      gameController.playWinningsSounds(
        _payWinsEvent.data.totalLineWinnings,
        resourceManager.getController('stakeController').CurrentStake
      );

      _animWinsFinished = false;

      _gigabloxFactory.dimAllSymbols(true, 0.2);
      winlineAnimationController.startWinlineAnimations(_payWinsEvent.data, function () {
        //dimAllReels(true);
        // initial symbol anims now all finished
        _animWinsFinished = true;
      });
    }

    if (gameController.phase.timed(400)) {
    }

    // show winnings value in middle of screen
    if (gameController.phase.once()) {
      gameData.winningsText.show(true, 0);
    }

    // grow to size and count up
    if (gameController.phase.timed(400)) {
      if (_skipWin) {
        gameController.phase.step();
        gameData.winningsText.setText(_payWinsEvent.data.totalLineWinningsNonMultiplied);
      } else {
        const appearProgress = Math.min(0.5 + gameController.phase.Progress, 1);
        gameData.winningsText.setScale(appearProgress);
        gameData.winningsText.alpha = appearProgress;
        gameData.winningsText.setText(
          Math.floor(gameController.phase.Progress * _payWinsEvent.data.totalLineWinningsNonMultiplied)
        );
      }
    }

    if (gameController.phase.timed(500)) {
    }

    if (gameController.phase.once()) {
      gameData.winningsText.setScale(1);
      gameData.winningsText.setText(_payWinsEvent.data.totalLineWinningsNonMultiplied);
    }

    if (gameController.phase.hold()) {
      // Ensure winline animations have finished
      if (_animWinsFinished) {
        //dimAllReels(false);
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      gameData.winningsText.setScale(1);

      if (_payWinsEvent.data.multiplier > 1) {
        console.log("GameController.switchState('AWARD_MULTIPLIER')");
        gameController.stateMachine.switchState('AWARD_MULTIPLIER');
      } else {
        console.log("GameController.switchState('PRE_POP_SYMBOLS')");
        gameController.stateMachine.switchState('PRE_POP_SYMBOLS');
      }
    }
  });

  ///////////////////////////////////////////////////
  gameController.skipWins = function () {
    _skipWin = true;
  };

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('AWARD_MULTIPLIER', function () {
    if (gameController.phase.once()) {
      gameData.winningsText.resetMultiplierPosition();
      gameData.winningsText.setMultiplier(_payWinsEvent.data.multiplier);
    }

    // for skip wins we need to skip the anim

    // --- Scale up multiplier ---
    if (gameController.phase.timed(400)) {
      if (_skipWin) {
        gameController.phase.step();
      } else {
        gameData.winningsText.setMultiplierScale(gameController.phase.Progress);
      }
    }

    if (gameController.phase.once()) {
      if (_payWinsEvent.data.multiplier >= 32) {
        soundManager.play('winMultiplierBig');
      } else if (_payWinsEvent.data.multiplier >= 8) {
        soundManager.play('winMultiplierMed');
      } else {
        soundManager.play('winMultiplierLow');
      }
      gameData.winningsText.setMultiplierScale(1);
    }

    // --- Give player a chance to see multiplier ---
    if (gameController.phase.timed(700)) {
      if (_skipWin) {
        gameController.phase.step();
      } else {
        gameData.winningsText.setGlow(Math.sin(Math.PI * gameController.phase.Progress));
      }
    }
    if (gameController.phase.once()) {
      //soundManager.play("Symbol – Logo");

      gameData.winningsText.setGlow(0);
      gameData.winningsText.moveMultiplier(_payWinsEvent.data.totalLineWinnings, _skipWin);
    }

    if (gameController.phase.hold()) {
      if (!gameData.winningsText.movingMuliplier || _skipWin) {
        if (!_skipWin) {
          soundManager.play('winCountUp');
        } else {
          if (gameData.winningsText.moveTween && gameData.winningsText.moveTween.isActive()) {
            // which should stop the tween straight away
            gameData.winningsText.moveTween.progress(1);
          }
        }
        gameController.phase.step();
      }
    }

    // --- Scale down multiplier and increment winnings ---
    if (gameController.phase.timed(500)) {
      var delta = _payWinsEvent.data.totalLineWinnings - _payWinsEvent.data.totalLineWinningsNonMultiplied;

      if (_skipWin) {
        gameController.phase.step();
      } else {
        // gameData.winningsText.setMultiplierScale(
        //   1 - gameController.phase.Progress
        // );
        gameData.winningsText.setText(
          _payWinsEvent.data.totalLineWinningsNonMultiplied + delta * gameController.phase.Progress
        );
      }
    }

    // if (_skipWin) {
    //   if (gameController.phase.timed(400)) {
    //     gameData.winningsText.setText(_payWinsEvent.data.totalLineWinningsNonMultiplied);
    //   }
    // }

    if (gameController.phase.once()) {
      // added here to fix rounding errors
      gameData.winningsText.setText(_payWinsEvent.data.totalLineWinnings);
      soundManager.stop('winCountUp');
      soundManager.play('winCountUpEnd');

      gameData.winningsText.setMultiplierScale(0);
      gameData.winningsText.setGlow(0);

      console.log("GameController.switchState('PRE_POP_SYMBOLS')");
      gameController.stateMachine.switchState('PRE_POP_SYMBOLS');
    }

    // if (gameController.phase.timed(1000)){
    //     gameData.winningsText.position.y = gameData.winningsText.position.y + ( 300 * gameController.phase.Progress );
    // 	gameData.winningsText.alpha = 1 - gameController.phase.Progress;
    // }
  });

  ////////////////////////////////////////////////////
  gameController.stateMachine.addState('MAX_WIN_POPUP', function (stateDataStore) {
    if (gameController.phase.enter()) {
      stateDataStore.popupAck = false;
      stateDataStore.maxWinPopup = resourceManager.get('maxWinPopupContainer:MaxWinPopup');
    }

    if (gameController.phase.timed(250)) {
    }

    if (gameController.phase.once()) {
      _gigabloxFactory.dimAllSymbols(false, 0.2);
      winlineAnimationController.clearAnimations(() => {
        _animWinsFinished = true;
      });

      // now we show the pop up panel
      stateDataStore.maxWinPopup.show(() => {
        stateDataStore.popupAck = true;
      });
    }

    // and wait for it to be dismissed
    if (gameController.phase.hold()) {
      if (stateDataStore.popupAck === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log("GameController.switchState('WAITING_FOR_SERVER')");
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');
      _payWinsEvent.leave();
    }
  });

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('PRE_POP_SYMBOLS', function () {
    if (gameController.phase.once()) {
    }

    if (gameController.canCelebrate || freespins.inFreespins) {
      if (gameController.phase.timed(500)) {
        gameData.winningsText.setScale(1 + Math.sin(gameController.phase.Progress * Math.PI) * 0.2);
      }
    } else {
      if (gameController.phase.timed(100)) {
      }
    }

    if (gameController.phase.once()) {
      gameData.winningsText.setScale(1);
      gameData.winningsText.setText(_payWinsEvent.data.totalLineWinnings);

      _winMeterContainer.visible = true;
      gameData.winningsMeter.countUp(_payWinsEvent.data.totalLineWinnings, 0);
    }

    if (gameController.phase.once()) {
      const isBigWin = _bigWin.willTriggerBigWin(
        _payWinsEvent.data.totalLineWinnings, //
        gameController.globalHelperGetBaseStake()
      );

      // Don't show big win in free spins - do it at the end of all free spins
      if (isBigWin) {
        _bigWin.start({
          winAmount: _payWinsEvent.data.totalLineWinnings,
          whereFrom: 'basegame',
          shortVersion: true,
          cbOnInitialDelayFinished: () => {
            gameData.winningsText.animateForBigWin();
          },
          cbOnOutroStart: () => {
            gameData.winningsText.restoreAfterBigWin();
          },
        });
      }
    }

    if (gameController.phase.hold()) {
      // Wait for big win to complete
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      _poppingSymbols = [];
      if (_payWinsEvent.data.winCapped !== true) {
        // Pop all symbols
        const winningLines = _payWinsEvent.data.winningLines;

        _poppingSymbols = [];
        for (let line = 0; line < winningLines.length; line++) {
          for (let symbolIndex = 0; symbolIndex < winningLines[line].positions.length; symbolIndex++) {
            const position = winningLines[line].positions[symbolIndex];

            // Check if we have already added this symbol (multiple winlines may cross the same symbol)
            let found = false;
            for (let j = 0; j < _poppingSymbols.length && !found; j++) {
              found = _poppingSymbols[j].reel === position.reel && _poppingSymbols[j].row === position.row;
            }

            if (!found) {
              // Add this to symbols we need to pop
              _poppingSymbols.push({ reel: position.reel, row: position.row });
            }
          }
        }
      } else {
        // max win reached, no point in doing anything
      }
    }

    if (gameController.phase.once()) {
      gameData.winningsText.show(false, null, true);

      if (_payWinsEvent.data.winCapped === true) {
        console.log("GameController.switchState('MAX_WIN_POPUP')");
        gameController.stateMachine.switchState('MAX_WIN_POPUP');
      } else {
        console.log("GameController.switchState('WAITING_FOR_SERVER')");
        gameController.stateMachine.switchState('WAITING_FOR_SERVER');
        _payWinsEvent.leave();
      }
    }
  });

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('MOVE_GOLDEN_CLAW_REEL', function () {
    const goldenClawModifier = resourceManager.get('goldenClawModifier:goldenClawModifier');

    if (gameController.phase.enter()) {
    }

    if (gameController.phase.once()) {
      _animWinsFinished = false;
      _gigabloxFactory.dimAllSymbols(false, 0.2);
      winlineAnimationController.clearAnimations(() => {
        _animWinsFinished = true;
      });
    }

    if (gameController.phase.hold()) {
      // wait for animations to clear
      if (_animWinsFinished === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      goldenClawModifier.moveReelsToTheLeft(_dropEvent);
    }

    if (gameController.phase.hold()) {
      if (goldenClawModifier.haveReelsMovedToTheLeft() === true) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // now we can continue to process wins
      console.log("GameController.switchState('DROP_SYMBOLS')");
      gameController.stateMachine.switchState('DROP_SYMBOLS');
    }

    if (gameController.phase.exit()) {
    }
  });

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('DROP_SYMBOLS', function (stateDataStore, allStatesDataStore) {
    const numRows = 5;
    if (gameController.phase.enter()) {
      _dropEvent.temp = {};
      _dropEvent.temp.totalDropping = [];

      stateDataStore.wildAppearSymbols = [];
      stateDataStore.playedDisappearAnims = [];
      stateDataStore.wildsToShow = [];
      stateDataStore.wildsToShowOnReel = [];
      stateDataStore.wildTypeToShow = -1;
      stateDataStore.popSymbolsData = [];
      stateDataStore.popData = [];
      stateDataStore.popDataGiga = [];
      stateDataStore.playedWildBlastAnims = [];
      stateDataStore.playedWildBlastAnimsGiga = [];
      stateDataStore.wildTypeToShow = 0;
    }

    if (gameController.phase.once()) {
      if (_goldenClawMoveReels !== true) {
        _animWinsFinished = false;
        _gigabloxFactory.dimAllSymbols(false, 0.2);
        winlineAnimationController.clearAnimations(() => {
          _animWinsFinished = true;
        });
      } else {
        _animWinsFinished = true;
      }
    }

    if (gameController.phase.once()) {
      console.log('Playing pop animation', _dropEvent.data.tumbleData);
      const totalDropping = [];
      for (let reel = 0; reel < _dropEvent.data.tumbleData.length; reel++) {
        stateDataStore.playedDisappearAnims[reel] = [];
        const popData = [];
        totalDropping[reel] = 0;
        for (let row = 0; row < numRows; ++row) {
          let shouldPop = _dropEvent.data.tumbleData[reel][row] !== 0;
          popData.push(shouldPop);

          if (shouldPop) {
            let anim = _symbolDisappearAnims[reel][row];
            // anim.visible = true;
            // anim.gotoAndPlay(0);
            stateDataStore.playedDisappearAnims[reel].push({
              anim: anim,
              row: row,
            });
            totalDropping[reel]++;
          }
        }

        if (!Utils.isArray(stateDataStore.wildsToShowOnReel[reel])) {
          stateDataStore.wildsToShowOnReel[reel] = [];
        }

        // now wilds
        if (_dropEvent.data.cells.length > 0) {
          for (let i = 0; i < _dropEvent.data.cells.length; ++i) {
            let cell = _dropEvent.data.cells[i];
            if (cell.reel === reel) {
              if (!cell.replacingAPoppedSymbol) {
                // we are replacing a symbol thats not part of a win!!!
                // should we do anything different?
              } else {
                // this wild is replacing a popped position
                // We are also going to add a wild here, so pop symbol first
                // Note this is a fake pop, it isnt included in the drop data, we just simulate the pop
                let anim = _symbolDisappearAnims[cell.reel][cell.row];
                // anim.visible = true;
                // anim.gotoAndPlay(0);
                stateDataStore.playedDisappearAnims[reel].push({
                  anim: anim,
                  row: cell.row,
                });
              }
              let wildToShow = {
                reel: cell.reel,
                row: cell.row,
                replacingAPoppedSymbol: cell.replacingAPoppedSymbol,
                anim: _wildAwardAnims[cell.reel][cell.row],
              };
              stateDataStore.wildsToShowOnReel[cell.reel].push(wildToShow);
              stateDataStore.wildsToShow.push(wildToShow);
              stateDataStore.wildTypeToShow = 0;
            }
          }
        }

        // Tell reels to pop (wait for drop)
        stateDataStore.popData[reel] = popData;
      }

      // before we play the disappearedAnims, can we work out which ones are actually needed?
      // which ones need to be bigger?
      // can we get the blockData for this reel?
      const playedDisappearAnimsGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        stateDataStore.playedDisappearAnims,
        gameController.blockDistributionData.blockDistribution
      );
      stateDataStore.previousBlockData = [];
      // we now only have the 1st reel of the gigablox explosions
      const gigaReels = _gigabloxFactory.getReelVisuals();
      for (let reel = 0; reel < playedDisappearAnimsGiga.length; reel++) {
        const blockData = gigaReels[reel]._blockData;
        stateDataStore.previousBlockData[reel] = blockData.slice(0);
        const anims = playedDisappearAnimsGiga[reel];
        for (let a = 0; a < anims.length; a++) {
          const animData = anims[a];
          let playAnim = false;
          if (gigaReels[reel]._blockSize === 2) {
            // scale up the anim
            // is this the top or the bottom of a giga symbol?
            // lets ignore the top part, and we make the bottom anim do the work
            if (blockData[animData.row] === 1) {
              // bottom part of the symbol,
              // we need to move it up and to the
              animData.anim.x += 126 / 2;
              animData.anim.y -= 126 / 2;
              animData.anim.scale.set(0.97);
              playAnim = true;
            } else {
              // top part, we aint playing this one
              // unless its the bottom symbol
              if (animData.row === Globals.NUM_ROWS - 1) {
                animData.anim.x += 126 / 2;
                animData.anim.y += 126 / 2;
                animData.anim.scale.set(0.97);
                playAnim = true;
              }
            }
          } else if (gigaReels[reel]._blockSize === 3) {
            // scale up the anim
            // is this the top or the bottom of a giga symbol?
            // lets ignore the top part, and we make the bottom anim do the work

            if (blockData[animData.row] === 2) {
              // bottom part of the symbol,
              // we need to move it up and to the
              animData.anim.x += 126;
              animData.anim.y -= 126;
              animData.anim.scale.set(1.455);
              playAnim = true;
            } else {
              // top part, we aint playing this one
              // unless its the bottom symbol
              if (animData.row === Globals.NUM_ROWS - 1) {
                if (blockData[animData.row] === 0) {
                  animData.anim.x += 126;
                  animData.anim.y += 126;
                  animData.anim.scale.set(1.455);
                  playAnim = true;
                } else {
                  // must be 1
                  animData.anim.x += 126;
                  // anim.anim.y += 126;
                  animData.anim.scale.set(1.455);
                  playAnim = true;
                }
              }
            }
          } else {
            playAnim = true;
            animData.anim.scale.set(0.485);
          }

          if (playAnim === true) {
            animData.anim.visible = true;
            animData.anim.gotoAndPlay(0);
          }
        }
      }

      // stateDataStore.popData populated and required disappear anims playing

      const fillingSlots = [];
      for (let reel = 0; reel < _dropEvent.data.tumbleData.length; ++reel) {
        // adjust popData to see whats moving
        // taking sticky wilds into account - which we dont have
        fillingSlots[reel] = [...stateDataStore.popData[reel]];
        for (let i = fillingSlots[reel].length - 1; i >= 0; i--) {
          if (fillingSlots[reel][i]) {
            for (let j = i; j >= 0; j--) {
              if (!fillingSlots[reel][j]) {
                fillingSlots[reel][i] = false;
                fillingSlots[reel][j] = true;
                break;
              }
            }
          }
        }
      }

      // fillingSlots populated

      // convert data so far ready for the gigaFactory
      const fillingSlotsGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        fillingSlots,
        gameController.blockDistributionData.blockDistribution
      );
      stateDataStore.fillingSlotsGiga = fillingSlotsGiga;
      const tumbleDataGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        _dropEvent.data.tumbleData,
        gameController.blockDistributionData.blockDistribution
      );
      stateDataStore.tumbleDataGiga = tumbleDataGiga;
      const windowGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        _dropEvent.data.window,
        gameController.blockDistributionData.blockDistribution
      );
      stateDataStore.windowGiga = windowGiga;
      const totalDroppingGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        totalDropping,
        gameController.blockDistributionData.blockDistribution
      );
      stateDataStore.totalDroppingGiga = totalDroppingGiga;

      const soundIndex = Math.floor(Math.random() * _explodeSounds.length);
      soundManager.play(_explodeSounds[soundIndex]);
    }

    if (gameController.phase.timed(250)) {
      // wait a bit before we remove symbols not being used
    }

    // this puts new symbol into where they will be
    if (gameController.phase.once()) {
      // use this to populate new symbols on the reels
      const gigaReels = _gigabloxFactory.getReelVisuals();
      for (let reel = 0; reel < gigaReels.length; ++reel) {
        // Change symbols that are going to drop in
        let slot = stateDataStore.windowGiga[reel];
        let dropCount = 0;
        const reelObject = gigaReels[reel];
        for (let i = 0; i < slot.length; i++) {
          if (stateDataStore.fillingSlotsGiga[reel][i]) {
            let newSymbol = slot[i]._id;
            if (newSymbol !== 10) {
              // dont replace symbols with wilds just yet
              reelObject.setReelSymbol(dropCount - stateDataStore.totalDroppingGiga[reel], newSymbol);
            } else {
              // we will be a wild
              // will we be replacing a 2x2 or a 3x3 which is off the top?
              // if so, we just need to double check the pre symbols are setup correctly
              // reelObject._blockSize is the width
              if (reelObject._blockSize > 1 && dropCount - stateDataStore.totalDroppingGiga[reel] + 1 === 0) {
                const rsd = reelObject.getReelSpinnerData();
                const symbol = rsd._symbolData[dropCount - stateDataStore.totalDroppingGiga[reel] + 1].symId;
                reelObject.setReelSymbol(dropCount - stateDataStore.totalDroppingGiga[reel], symbol);
              }
            }
            dropCount++;
          }
        }
      }

      _gigabloxFactory.redraw();

      // so we have stateDataStore.popData to convert
      stateDataStore.popDataGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        stateDataStore.popData,
        gameController.blockDistributionData.blockDistribution
      );
      const aboveAfter = Utils.shrinkArrayBasedOnBlockDistribution(
        _dropEvent.data.aboveAfter,
        gameController.blockDistributionData.blockDistribution,
        false // we dont want to clone the array, otherwise they will never shrink
      );

      stateDataStore.popSymbolsData = _gigabloxFactory.popSymbols(
        stateDataStore.popDataGiga,
        () => {
          // instant so we dont need to wait for anything to finish
          console.log('_gigabloxFactory.popSymbols finished');
        },
        false,
        aboveAfter
      );

      _gigabloxFactory.clearSplitBlocks(); // dont need to see these now

      _gigabloxFactory.redraw();
    }

    // symbols that have popped have been removed
    // now we need to update where the wilds are going to go
    // and hide those - so it looks like they exploded

    if (gameController.phase.once()) {
      // this bit is grabbing the symbols which are going to be turned into wilds
      // and making sure we have a reference to the symbol
      // so we can fade in underneath another animation
      const wildsToShowOnReelGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        stateDataStore.wildsToShowOnReel,
        gameController.blockDistributionData.blockDistribution
      );
      stateDataStore.wildsToShowOnReelGiga = wildsToShowOnReelGiga;

      const gigaReels = _gigabloxFactory.getReelVisuals();
      for (let reel = 0; reel < gigaReels.length; ++reel) {
        const symbolGfx = gigaReels[reel].getSymbolGfx();
        for (let i = 0; i < wildsToShowOnReelGiga[reel].length; i++) {
          const { row, replacingAPoppedSymbol } = wildsToShowOnReelGiga[reel][i];
          if (Utils.isNumber(stateDataStore.popSymbolsData[reel].indexBecomes[row])) {
            symbol = symbolGfx[stateDataStore.popSymbolsData[reel].indexBecomes[row]].symbol;
          } else {
            symbol = symbolGfx[row].symbol;
          }
          if (replacingAPoppedSymbol) {
            symbol.visible = false;
            symbol.alpha = 0;
          } else {
            // we arent replacing a popped symbol, so we dont need to hide the symbol
          }
          stateDataStore.wildAppearSymbols.push(symbol);
        }
      }
    }

    // now that popSymbols has been called we need to get the references to the correct symbols
    // which are turning into wilds
    // and hide them behind the explosion anim
    if (gameController.phase.hold()) {
      // We are waiting for all symbols pops to fly to torch
      let animsDone = true;
      for (let reel = 0; reel < stateDataStore.playedDisappearAnims.length && animsDone; reel++) {
        for (let i = 0; i < stateDataStore.playedDisappearAnims[reel].length && animsDone; i++) {
          const anim = stateDataStore.playedDisappearAnims[reel][i].anim;
          if (anim.playing) {
            animsDone = false;
          }
        }
      }

      if (animsDone) {
        console.log('pop anims finished');
        for (let reel = 0; reel < stateDataStore.playedDisappearAnims.length; reel++) {
          for (let i = 0; i < stateDataStore.playedDisappearAnims[reel].length; i++) {
            const anim = stateDataStore.playedDisappearAnims[reel][i].anim;
            anim.visible = false;
            anim.scale.set(0.97);
            anim.x = anim.origX;
            anim.y = anim.origY;
          }
        }
        gameController.phase.step();
      }
    }

    // we need to make wilds appear now
    // we have a special anim wildBlast which will play and we make the wild symbol appear
    // underneath
    if (gameController.phase.once()) {
      for (let reel = 0; reel < reelManager.reels.length; ++reel) {
        stateDataStore.playedWildBlastAnims[reel] = [];
        if (_dropEvent.data.cells.length > 0) {
          for (let i = 0; i < _dropEvent.data.cells.length; ++i) {
            const cell = _dropEvent.data.cells[i];
            if (cell.reel === reel) {
              const row = cell.row;
              stateDataStore.playedWildBlastAnims[reel].push({
                reel: reel,
                row: cell.row,
                anim: _wildBlastAnims[reel][row],
              });
            }
          }
        }
      }

      stateDataStore.playedWildBlastAnimsGiga = Utils.shrinkArrayBasedOnBlockDistribution(
        stateDataStore.playedWildBlastAnims,
        gameController.blockDistributionData.blockDistribution
      );
    }

    if (gameController.phase.once()) {
      // now we need to add the wilds to the current gigablox reels
      const gigaReels = _gigabloxFactory.getReelVisuals();
      let wildToUse = resourceManager.getConfiguration().symbols.Wild.ID;
      for (let reel = 0; reel < gigaReels.length; ++reel) {
        const reelObject = gigaReels[reel];
        const numPerReel = stateDataStore.wildsToShowOnReelGiga[reel].length;
        for (let i = 0; i < stateDataStore.wildsToShowOnReelGiga[reel].length; i++) {
          const row = stateDataStore.wildsToShowOnReelGiga[reel][i].row;
          let index = -1;
          if (Utils.isNumber(stateDataStore.popSymbolsData[reel].indexBecomes[row])) {
            // if the number is 0, we also want to set the ones above
            index = stateDataStore.popSymbolsData[reel].indexBecomes[row];
          } else {
            index = row; //reelObject.setReelSymbol(row, wildToUse);
          }
          reelObject.setReelSymbol(index, wildToUse);

          if (reelObject._blockSize > 1) {
            // just making sure the pre aperature symbols are correct
            // if row is 0 - which is before anything has dropped
            // look to see if we need to populate previous symbols
            if (row === 0 && numPerReel === 1 && reelObject._blockSize === 2) {
              reelObject.setReelSymbol(index - 1, wildToUse);
            } else if (row === 0 && numPerReel === 1 && reelObject._blockSize === 3) {
              reelObject.setReelSymbol(index - 1, wildToUse);
              reelObject.setReelSymbol(index - 2, wildToUse);
            } else if (row === 0 && numPerReel === 2 && reelObject._blockSize === 3) {
              reelObject.setReelSymbol(index - 1, wildToUse);
            }
          }
        }
      }

      // _windowBlockInfo needs updating again here
      _gigabloxFactory.recalculateWindowBlockInfo();
      for (let i = 0; i < gigaReels.length; i++) {
        gigaReels[i].recalculateBlockData();
        if (gigaReels[i]._blockSize > 1) {
          gigaReels[i].updateClipRects();
        }
      }

      for (let i = 0; i < stateDataStore.wildAppearSymbols.length; i++) {
        stateDataStore.wildAppearSymbols[i].visible = true;
        stateDataStore.wildAppearSymbols[i].renderable = true;
        stateDataStore.wildAppearSymbols[i].alpha = 0;
      }
    }

    if (gameController.phase.once()) {
      // this is almost duplicate code as the explosion, could we make it generic and pass
      // in a few options to a function?

      if (stateDataStore.wildAppearSymbols.length > 0) {
        soundManager.play('standardWild');
      }

      const gigaReels = _gigabloxFactory.getReelVisuals();
      for (let reel = 0; reel < stateDataStore.playedWildBlastAnimsGiga.length; reel++) {
        const blockData = stateDataStore.previousBlockData[reel];
        for (let i = 0; i < stateDataStore.playedWildBlastAnimsGiga[reel].length; i++) {
          const animData = stateDataStore.playedWildBlastAnimsGiga[reel][i];
          let playAnim = false;
          if (gigaReels[reel]._blockSize === 2) {
            // scale up the anim
            // is this the top or the bottom of a giga symbol?
            // lets ignore the top part, and we make the bottom anim do the work
            if (blockData[animData.row] === 1) {
              // bottom part of the symbol,
              // we need to move it up and to the
              animData.anim.x += 126 / 2;
              animData.anim.y -= 126 / 2;
              animData.anim.scale.set(2.4);
              playAnim = true;
            } else {
              // top part, we aint playing this one
              // unless its the bottom symbol
              if (animData.row === Globals.NUM_ROWS - 1) {
                animData.anim.x += 126 / 2;
                animData.anim.y += 126 / 2;
                animData.anim.scale.set(2.4);
                playAnim = true;
              }
            }
          } else if (gigaReels[reel]._blockSize === 3) {
            // scale up the anim
            // is this the top or the bottom of a giga symbol?
            // lets ignore the top part, and we make the bottom anim do the work

            if (blockData[animData.row] === 2) {
              // bottom part of the symbol,
              // we need to move it up and to the
              animData.anim.x += 126;
              animData.anim.y -= 126;
              animData.anim.scale.set(3.6);
              playAnim = true;
            } else {
              // top part, we aint playing this one
              // unless its the bottom symbol
              if (animData.row === Globals.NUM_ROWS - 1) {
                if (blockData[animData.row] === 0) {
                  animData.anim.x += 126;
                  animData.anim.y += 126;
                  animData.anim.scale.set(3.6);
                  playAnim = true;
                } else {
                  // must be 1
                  animData.anim.x += 126;
                  // anim.anim.y += 126;
                  animData.anim.scale.set(3.6);
                  playAnim = true;
                }
              }
            }
          } else {
            playAnim = true;
            animData.anim.scale.set(1.2);
          }

          if (playAnim === true) {
            // animData.anim.origParent.addChild(animData.anim);
            animData.anim.origParent.addChild(animData.anim);
            animData.anim.visible = true;
            animData.anim.gotoAndPlay(0);
          }
        }
      }
    }

    if (gameController.phase.timed(250)) {
      // wait a bit
    }

    if (gameController.phase.timed(250)) {
      for (let i = 0; i < stateDataStore.wildAppearSymbols.length; i++) {
        stateDataStore.wildAppearSymbols[i].alpha = gameController.phase.Progress;
      }
    }

    if (gameController.phase.hold()) {
      let animsDone = true;
      for (let reel = 0; reel < stateDataStore.playedWildBlastAnimsGiga.length && animsDone === true; reel++) {
        for (let i = 0; i < stateDataStore.playedWildBlastAnimsGiga[reel].length && animsDone === true; i++) {
          const anim = stateDataStore.playedWildBlastAnimsGiga[reel][i];
          if (anim.playing) {
            animsDone = false;
          }
        }
      }
      if (animsDone) {
        console.log('wild blast anims finished');
        for (let reel = 0; reel < stateDataStore.playedWildBlastAnimsGiga.length && animsDone === true; reel++) {
          for (let i = 0; i < stateDataStore.playedWildBlastAnimsGiga[reel].length && animsDone === true; i++) {
            const anim = stateDataStore.playedWildBlastAnimsGiga[reel][i].anim;
            anim.gotoAndStop(0);
            anim.x = anim.origX;
            anim.y = anim.origY;
            anim.scale.set(1);
            anim.visible = false;
            if (anim.parent) {
              anim.parent.removeChild(anim);
            }
          }
        }
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // this is almost duplicate code as the explosion, could we make it generic and pass
      // in a few options to a function?
      const gigaReels = _gigabloxFactory.getReelVisuals();
      for (let reel = 0; reel < stateDataStore.wildsToShowOnReelGiga.length; reel++) {
        const blockData = stateDataStore.previousBlockData[reel];
        for (let i = 0; i < stateDataStore.wildsToShowOnReelGiga[reel].length; i++) {
          const animData = stateDataStore.wildsToShowOnReelGiga[reel][i];
          let playAnim = false;
          if (gigaReels[reel]._blockSize === 2) {
            // scale up the anim
            // is this the top or the bottom of a giga symbol?
            // lets ignore the top part, and we make the bottom anim do the work
            if (blockData[animData.row] === 1) {
              // bottom part of the symbol,
              // we need to move it up and to the
              animData.anim.x += 126 / 2;
              animData.anim.y -= 126 / 2;
              animData.anim.scale.set(1);
              playAnim = true;
            } else {
              // top part, we aint playing this one
              // unless its the bottom symbol
              if (animData.row === Globals.NUM_ROWS - 1) {
                animData.anim.x += 126 / 2;
                animData.anim.y += 126 / 2;
                animData.anim.scale.set(1);
                playAnim = true;
              }
            }
          } else if (gigaReels[reel]._blockSize === 3) {
            // scale up the anim
            // is this the top or the bottom of a giga symbol?
            // lets ignore the top part, and we make the bottom anim do the work

            if (blockData[animData.row] === 2) {
              // bottom part of the symbol,
              // we need to move it up and to the
              animData.anim.x += 126;
              animData.anim.y -= 126;
              animData.anim.scale.set(1.5);
              playAnim = true;
            } else {
              // top part, we aint playing this one
              // unless its the bottom symbol
              if (animData.row === Globals.NUM_ROWS - 1) {
                if (blockData[animData.row] === 0) {
                  animData.anim.x += 126;
                  animData.anim.y += 126;
                  animData.anim.scale.set(1.5);
                  playAnim = true;
                } else {
                  // must be 1
                  animData.anim.x += 126;
                  // anim.anim.y += 126;
                  animData.anim.scale.set(1.5);
                  playAnim = true;
                }
              }
            }
          } else {
            playAnim = true;
            animData.anim.scale.set(0.5);
          }

          if (playAnim === true) {
            animData.anim.origParent.addChild(animData.anim);
            animData.anim.visible = true;
            animData.anim.gotoAndPlay(0);
          }
        }
      }
    }

    if (gameController.phase.hold()) {
      // We are waiting for all symbols pops to fly to torch
      let animsDone = true;
      for (let reel = 0; reel < stateDataStore.wildsToShowOnReelGiga.length && animsDone; reel++) {
        for (let i = 0; i < stateDataStore.wildsToShowOnReelGiga[reel].length && animsDone; i++) {
          if (stateDataStore.wildsToShowOnReelGiga[reel][i]) {
            const anim = stateDataStore.wildsToShowOnReelGiga[reel][i].anim;
            if (anim.playing) {
              animsDone = false;
            }
          }
        }
      }

      if (animsDone) {
        console.log('wild award finished');
        // now remove them all
        for (let reel = 0; reel < stateDataStore.wildsToShowOnReelGiga.length && animsDone; reel++) {
          for (let i = 0; i < stateDataStore.wildsToShowOnReelGiga[reel].length && animsDone; i++) {
            if (stateDataStore.wildsToShowOnReelGiga[reel][i]) {
              const anim = stateDataStore.wildsToShowOnReelGiga[reel][i].anim;
              anim.gotoAndStop(0);
              anim.visible = false;
              anim.x = anim.origX;
              anim.y = anim.origY;
              if (anim.parent) {
                anim.parent.removeChild(anim);
              }
            }
          }
        }
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      // now we can tell the current giga reels to drop
      const soundIndex = Math.floor(Math.random() * _cascadeSounds.length);
      soundManager.play(_cascadeSounds[soundIndex]);

      stateDataStore.dropsComplete = false;
      _gigabloxFactory.dropSymbols(stateDataStore.popDataGiga, () => {
        console.log('_gigabloxFactory:dropSymbols - complete');
        _gigabloxFactory.redraw();
        const blockDistributionData = gameController.blockDistributionData;
        blockDistributionData.board = _dropEvent.data.board;
        stateDataStore.dropsComplete = true;
      });

      if (_payWinsEvent !== undefined) {
        if (_payWinsEvent.data.multiplier < 2) {
          _multiplierDisplay.openDoor();
        } else {
          // This is a subsequent multiplier so increase multiplier
          _multiplierDisplay.increaseMultiplier(_payWinsEvent.data.multiplier);
        }
      }
    }

    if (gameController.phase.hold()) {
      if (stateDataStore.dropsComplete === true && _multiplierDisplay.isIdle()) {
        _gigabloxFactory.recalculateWindowBlockInfo();
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      console.log("GameController.switchState('WAITING_FOR_SERVER')");
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');
      _dropEvent.leave();
    }

    if (gameController.phase.exit()) {
    }
  });

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('PAY_TO_WINNINGS', function () {
    if (gameController.phase.once()) {
      musicManager.restartReturnTimer();

      const isBigWin = _bigWin.willTriggerBigWin(
        _popAndDropCompleteEvent.data.winnings, //
        gameController.globalHelperGetBaseStake()
      );

      // Don't show big win in free spins - do it at the end of all free spins
      if (isBigWin && !freespins.inFreespins && !_popAndDropCompleteEvent.data.triggeringFreeSpins) {
        _bigWin.start({
          winAmount: _popAndDropCompleteEvent.data.winnings,
          whereFrom: 'basegame',
          delayInMS: 300,
        });
      }
    }

    if (gameController.phase.hold()) {
      // Wait for big win to complete
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (
      gameController.canCelebrate &&
      !freespins.inFreespins &&
      !_bigWin.willTriggerBigWin(
        _popAndDropCompleteEvent.data.winnings, //
        gameController.globalHelperGetBaseStake()
      )
    ) {
      if (gameController.phase.timed(200)) {
      }
      if (gameController.phase.once()) {
        // for (var i = 0; i < reelManager.reels.length; i++) {
        //   reelManager.reels[i].dimAllSymbols(true, 0x666666);
        // }

        _gigabloxFactory.dimAllSymbols(true, 0.2);
        messageBox.show(true);
        messageBox.setMessage('t_totalRoundWin', '');
        gameData.winningsText.show(true, 0);
        soundManager.play('winCountUp');
        soundManager.play('totalWinIn');
        gsap.fromTo(
          gameData.winningsText,
          { pixi: { scale: 0, alpha: 0 } },
          {
            pixi: { scale: 1, alpha: 1 },
            duration: 0.5,
          }
        );
      }

      // grow to size and count up
      if (gameController.phase.timed(1000)) {
        var appearProgress = Math.min(0.5 + gameController.phase.Progress, 1);
        gameData.winningsText.setText(Math.floor(gameController.phase.Progress * _totalWinnings));
      }

      if (gameController.phase.once()) {
        soundManager.stop('winCountUp');
        soundManager.play('winCountUpEnd');
        gameData.winningsText.setScale(1);
        gameData.winningsText.alpha = 1;
        gameData.winningsText.setText(_totalWinnings);
      }

      if (gameController.phase.timed(800)) {
      }

      if (gameController.phase.once()) {
        _gigabloxFactory.dimAllSymbols(false, 0.2);
        messageBox.show(false);

        soundManager.play('totalWinOut');

        gsap.fromTo(
          gameData.winningsText,
          { pixi: { scale: 1, alpha: 1 } },
          {
            pixi: { scale: 0, alpha: 0 },
            ease: 'back.in',
            duration: 0.5,
            onComplete: () => {
              gameData.winningsText.show(false);
              gameData.winningsText.alpha = 1;
              gameData.winningsText.setScale(1);
            },
          }
        );

        // for (var i = 0; i < reelManager.reels.length; i++) {
        //   reelManager.reels[i].dimAllSymbols(false);
        // }
      }
    }

    /*     if (gameController.phase.once()) {
			if (gameController.canCelebrate || freespins.inFreespins) {
				soundManager.play("winCountUp");
			}
        }*/

    if (gameController.phase.once()) {
      if (freespins.inFreespins) {
        musicManager.freeSpinsNextLevel();
      }

      gameData.winningsMeterTitle.visible = true;
    }
    if (gameController.phase.timed(100)) {
    }
    if (gameController.phase.once()) {
      console.log("GameController.switchState('WAITING_FOR_SERVER')");
      gameController.stateMachine.switchState('WAITING_FOR_SERVER');
    }
    if (gameController.phase.exit()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState('enabled');
      }
      _popAndDropCompleteEvent.leave();
    }
  });

  ///////////////////////////////////////////////////
  gameController.stateMachine.addState('END_GAME', function () {
    if (gameController.phase.once()) {
      // End of game cycle
      if (_inBuyABonus) {
        // restore the original stake
        let stakeController = resourceManager.getController('stakeController');
        stakeController.broadcastCurrentStake('default');
      }

      gdk.endGame(function () {
        // do we need to check anything before enabling?
        _gigabloxFactory.enableSymbolHitAreas();
        console.log("GameController.switchState('WAIT_FOR_START')");
        gameController.stateMachine.switchState('WAIT_FOR_START');
      });

      // the above callback wont be called if we are a replay game
      // so we wont go to WAIT_FOR_START, which restarts the idle timer
      const sp = gdk.getServerParser();
      if (Utils.isFunction(sp.isRewatchMode) && Utils.isFunction(sp.isReplayMode)) {
        if (sp.isRewatchMode() || sp.isReplayMode()) {
          if (_finalWinningsForWinCycle > resourceManager.getController('stakeController').CurrentStake) {
            // start idle timer
            gameController.restartIdleTimer();
          }
        }
      }
    }
  });

  ///////////////////////////////////////////////////
  gameController.initialise = function () {
    localRNG = new RNG();

    const screenShaker = resourceManager.get('screenShaker');
    screenShaker.init([{ item: resourceManager.getContainer('gameContainer'), isContainer: true }]);

    const paytablePopup = resourceManager.get('slotContainer:paytablePopup:PaytablePopup');
    paytablePopup.init();
    _bigWin = resourceManager.get('bigWin:BigWin');
    _bigWin.init();
    _fiveOAK = resourceManager.get('fiveOAK:FiveOAK');
    _fiveOAK.init();
    freespins.initialise();
    _multiplierDisplay = resourceManager.get('multiDisplay:multiplierDisplay');

    _freeSpinsMeter = resourceManager.get('freeSpinsMeter');
    _freeSpinsMeter.initialise();

    _winMeterContainer = resourceManager.get('meterContainer:winnings');
    _winMeterContainer.visible = false;

    messageBox = resourceManager.get('slotContainer:messageBar');
    // const slamStopButton = resourceManager.get("buttonContainer:buttonBar:slamStopButton");
    // slamStopButton.canEnableBase = slamStopButton.canEnable;
    // slamStopButton.canEnable = function () {
    //     return this.canEnableBase() && gameController._receivedResponse;
    // };

    _volumeButton = resourceManager.get('buttonContainer:buttonBar:mute');
    _volumeButton.canShowBase = _volumeButton.canShow;
    _volumeButton.canShow = function () {
      return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
    };
    _volumeButtonBaseGameParent = resourceManager.get('buttonContainer:buttonBar:muteButtonBaseGameContainer');
    _volumeButtonFreeSpinsParent = resourceManager.get('buttonContainer:buttonBar:muteButtonFreeSpinsContainer');
    _volumeButtonBaseGameParent.addChild(_volumeButton);
    // when we go into free spins
    // _volumeButtonFreeSpinsParent.addChild(_volumeButton);

    gameController.setupSymbolDisappearAnims();
    gameController.setupWildBlastAnims();
    gameController.setupWildAwardAnims();
    gameController.setupAnticipationAnims();

    // not the best fix but should work to remove the button highlight
    // after leaving the htmlviewer.
    htmlViewer.onCloseBase = htmlViewer.onClose;
    htmlViewer.onClose = function () {
      htmlViewer.onCloseBase();
      settingsMenu.glow.visible = false;
      settingsMenu.hidePopup();
    };

    musicManager.onGameLoaded();

    _gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
    _gigabloxFactory.setAppertureData({
      landscape: [
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        // { scale: 0.7714, y: 91 },
        // { scale: 0.6714, y: 100 },
        // { scale: 0.5857, y: 98 },
      ],
      portrait: [
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        { scale: 1, y: 126 },
        // { scale: 0.85, y: 50 },
        // { scale: 0.8, y: 100 },
        // { scale: 0.75, y: 150 },
      ],
    });
    const startingSymbols = gameController.convertStartingSymbols(gameData.slotConfig.loadingBoard);
    _gigabloxFactory.setInitialSymbols(startingSymbols);
    _gigabloxFactory.enableSymbolHitAreas();
  };

  gameController.convertStartingSymbols = function (loadingBoard) {
    // we get something which looks like
    // const loadingBoard = {
    //   blockDistribution: '1-1-2-1',
    //   board: {
    //     columns: [
    //       {
    //         standardSize: 1,
    //         shift: 0,
    //         rows: [
    //           { height: 1, symbol: 3 },
    //           { height: 1, symbol: 7 },
    //           { height: 1, symbol: 7 },
    //           { height: 1, symbol: 6 },
    //           { height: 1, symbol: 6 },
    //         ],
    //       },
    //       {
    //         standardSize: 1,
    //         shift: 0,
    //         rows: [
    //           { height: 1, symbol: 0 },
    //           { height: 1, symbol: 1 },
    //           { height: 1, symbol: 5 },
    //           { height: 1, symbol: 3 },
    //           { height: 1, symbol: 6 },
    //         ],
    //       },
    //       {
    //         standardSize: 2,
    //         shift: 0,
    //         rows: [
    //           { height: 2, symbol: 2 },
    //           { height: 2, symbol: 8 },
    //           { height: 2, symbol: 4 },
    //         ],
    //       },
    //       {
    //         standardSize: 1,
    //         shift: 0,
    //         rows: [
    //           { height: 1, symbol: 3 },
    //           { height: 1, symbol: 3 },
    //           { height: 1, symbol: 3 },
    //           { height: 1, symbol: 3 },
    //           { height: 1, symbol: 4 },
    //         ],
    //       },
    //     ],
    //     stopWindow: {
    //       reels: 5,
    //       reelList: [
    //         { symbols: [{ value: 3 }, { value: 7 }, { value: 7 }, { value: 6 }, { value: 6 }] },
    //         { symbols: [{ value: 0 }, { value: 1 }, { value: 5 }, { value: 3 }, { value: 6 }] },
    //         { symbols: [{ value: 2 }, { value: 2 }, { value: 8 }, { value: 8 }, { value: 4 }] },
    //         { symbols: [{ value: 2 }, { value: 2 }, { value: 8 }, { value: 8 }, { value: 4 }] },
    //         { symbols: [{ value: 3 }, { value: 3 }, { value: 3 }, { value: 3 }, { value: 4 }] },
    //       ],
    //     },
    //   },
    // };

    // this needs converting to look like
    // const startingSymbols = [
    //   {layout:1, symbols:[{value:0},{value:0},{value:1},{value:2}]},  // 1 wide
    //   {layout:1, symbols:[{value:2},{value:3},{value:2},{value:1}]},  // 1 wide
    //   {layout:4, symbols:[{value:0},{value:0},{value:0},{value:1}]},  // 4 wide
    // ]

    const MAXROWS = 5;
    const startingSymbols = [];
    const columns = loadingBoard.board.columns;
    for (let c = 0; c < columns.length; c++) {
      const column = columns[c];
      // columns[c].shift details if the reel has overhang above
      const symbols = [];
      for (let r = 0; r < column.rows.length; r++) {
        // this is where shift is important
        // but as this same will be starting with 0 for now
        // e.g. if 1 i think we would only add 1 to start with, then 2 etc
        for (let s = 0; s < column.standardSize; s++) {
          if (symbols.length < MAXROWS) {
            symbols.push({ value: column.rows[r].symbol });
          }
        }
      }
      startingSymbols.push({
        layout: column.standardSize,
        symbols: symbols,
      });
    }

    return startingSymbols;
  };

  gameController.doGigabloxTransitionEffect = function (realReel, blockSize, callback, effectID) {
    // const symbolWidth = 140 * gameController.gigabloxFactory._activeSlotMachine.parent.scale.x;
    // const symbolHeight = 140 * gameController.gigabloxFactory._activeSlotMachine.parent.scale.y;
    // const height = gameController.numberOfActiveRows * symbolHeight + 150;
    // const x = gameController.gigabloxFactory._activeSlotMachine.parent.position.x + realReel * symbolWidth;
    // const x2 = x + blockSize * symbolWidth;
    // let extraRows = gameController.numberOfActiveRows - 4;
    // const y = layoutController.getCurrentLayoutProperties().landscape
    //   ? layoutController.getCurrentPosition(gameController.gigabloxTransitionParticles[0].BPprops.FQN).y
    //   : layoutController.getCurrentPosition(gameController.gigabloxTransitionParticles[0].BPprops.FQN).y -
    //     (symbolHeight * extraRows) / 2 +
    //     extraRows * 25;

    // gameController.gigabloxTransitionParticles[effectID * 2].position.setY(y);
    // gameController.gigabloxTransitionParticles[effectID * 2 + 1].position.setY(y);
    // gameController.gigabloxTransitionGlows[effectID * 2].position.setY(y);
    // gameController.gigabloxTransitionGlows[effectID * 2 + 1].position.setY(y);

    // gameController.gigabloxTransitionParticles[effectID * 2].position.setX(x);
    // gameController.gigabloxTransitionParticles[effectID * 2 + 1].position.setX(x2);
    // gameController.gigabloxTransitionParticles[effectID * 2].BPprops.landscape_default.position.x = x;
    // gameController.gigabloxTransitionParticles[effectID * 2 + 1].BPprops.landscape_default.position.x = x2;
    // gameController.gigabloxTransitionParticles[effectID * 2].BPprops.portrait_default.position.x = x;
    // gameController.gigabloxTransitionParticles[effectID * 2 + 1].BPprops.portrait_default.position.x = x2;
    // gameController.gigabloxTransitionParticles[effectID * 2].particleEmitter.spawnRect.height = height;
    // gameController.gigabloxTransitionParticles[effectID * 2 + 1].particleEmitter.spawnRect.height = height;

    // gameController.gigabloxTransitionGlows[effectID * 2].position.setX(x);
    // gameController.gigabloxTransitionGlows[effectID * 2 + 1].position.setX(x2);
    // gameController.gigabloxTransitionGlows[effectID * 2].BPprops.landscape_default.position.x = x;
    // gameController.gigabloxTransitionGlows[effectID * 2 + 1].BPprops.landscape_default.position.x = x2;
    // gameController.gigabloxTransitionGlows[effectID * 2].BPprops.portrait_default.position.x = x;
    // gameController.gigabloxTransitionGlows[effectID * 2 + 1].BPprops.portrait_default.position.x = x2;

    // for (let i = 0; i <= effectID * 2 + 1; ++i) {
    //   gameController.gigabloxTransitionParticles[i].particleEmitter.emit = true;
    //   gameController.gigabloxTransitionParticles[i].visible = true;
    //   gameController.gigabloxTransitionGlows[i].visible = true;
    // }

    timerManager.addTimeout(750, function () {
      gameController.stopGigabloxTransitionEffect();

      timerManager.addTimeout(700, function () {
        // give breathing space before starting anticipation
        callback();
      });
    });
  };

  gameController.stopGigabloxTransitionEffect = function () {
    // gameController.gigabloxTransitionParticles.forEach(function (particle) {
    //   particle.particleEmitter.emit = false;
    //   particle.visible = false;
    // });
    // gameController.gigabloxTransitionGlows.forEach(function (glow) {
    //   glow.visible = false;
    // });
  };

  gameController.rng = function () {
    return localRNG;
  };

  gameController.checkBuyBonus = function () {
    return _inBuyABonus;
  };

  ///////////////////////////////////////////////////
  gameController.globalHelperGetStake = function () {
    let stake = resourceManager.getController('stakeController').BaseStake;
    if (_inBuyABonus) {
      stake *= 100;
    }
    return stake;
  };

  gameController.globalHelperGetBaseStake = function () {
    let stake = resourceManager.getController('stakeController').BaseStake;
    return stake;
  };

  gameController.onStakeChanged = function (stake) {
    let stakeController = resourceManager.getController('stakeController');
    const currentStake = stakeController.Stakes[gameData.currentStakeIndex];
    if (currentStake !== stake) {
      _finalWinningsForWinCycle = 0;
      gameController.killShowLastWin();
      gameData.winningsMeter.set(0);
      gameData.currentStakeIndex = gameData.stakes.indexOf(stake);
      game.changeStake(stake);
    }
  };

  gameController.getCurrentModeStake = function (ignoreGoldenBetMultiplier) {
    let stake = 0;

    const stakeController = resourceManager.getController('stakeController');

    if (stakeController) {
      stake = stakeController.getCurrentStake('default');

      if (_inBuyABonus) {
        stake = stakeController.getCurrentStake(gameController.buyBonusMode);
      }
    }
    return stake;
  };

  ///////////////////////////////////////////////////
  gameController.onOrientationChange = function () {};

  gameController.playWinningsSounds = function (winnings, stake) {
    if (winnings <= stake) {
      // rely on the winline tinkle
      // soundManager.play('smallWin');
    } else if (winnings >= stake * 5) {
      soundManager.play(hiWinSounds[Math.floor(Math.random() * hiWinSounds.length)]);
    } else if (winnings > stake) {
      soundManager.play(loWinSounds[Math.floor(Math.random() * loWinSounds.length)]);
    }
  };

  gameController.cleanUpAboveSymbolsBeforeSpin = function () {
    // since the new giga stuff is in, i think we do need this to clean up
    // after some drops
    // using the block distribution, we need to make sure the symbols above
    // because of the way the reels spin off, we should be ok without needs to worry about the bottom ones
    // and we shouldnt need to worry anyway as the symbolsBelow from the comms should of done that for us
    // this is just after we have had multiple cascades
    // only going so far up in the hope that the injector rules sort the rest
    // i think we need the last lot of comms with this so we know what the shift is
    const widths = gameController.blockDistributionData.blockDistribution.split('-').map(Number);
    const board = gameController.blockDistributionData.board;
    const gigaReels = _gigabloxFactory.getReelVisuals();
    const symbols = _gigabloxFactory.getSymbolsInWindow();
    const bonusID = resourceManager.getConfiguration().symbols['Bonus'].ID;
    let anyUpdated = false;
    let blockDataTweak = [];
    for (let w = 0; w < widths.length; w++) {
      const width = widths[w];
      const reelObject = gigaReels[w];
      const column = board.columns[w];
      if (width > 1) {
        // symbols we want to replace in the pre, so it should look ok as we start spinning
        let startIndex = 0;
        const toAdd = Utils.randomPreSymbolsForPreSpinCleanUp(width);
        const height = column.rows[0].height;
        if (height === 1 || column.shift === 0) {
          // height of 1 means we have a bonus across the top
          // shift of 0 means symbols are perfectly aligned at the top, e.g. no upper overflow
          blockDataTweak[w] = width - 1; // 1 = bottom of 2x2 or 2 = bottom of 3x3
          // before we replace the 1st pre - make sure its not a bonus
          if (symbols[w][Globals.NUM_ROWS + Globals.NUM_PRE_APPERATURE_SYMBOLS - 1] === bonusID) {
            startIndex = 1;
          }
        } else {
          blockDataTweak[w] = column.shift - 1; // 0 = top of 2x2 or 0 = top of 3x3 1 = middle of 3x3
          const symbolToAdd = column.rows[0].symbol; // we know we cant be a bonus
          for (let e = 0; e < column.shift; e++) {
            // inject this symbol at the start of the array
            toAdd.unshift(symbolToAdd);
          }
        }
        for (let i = startIndex; i < Globals.NUM_PRE_APPERATURE_SYMBOLS; i++) {
          const pre = -1 + -1 * i;
          reelObject.setReelSymbol(pre, toAdd[i - startIndex]);
        }
        anyUpdated = true;
      } else {
        // normal reel, no need to worry about it
      }
    }

    if (anyUpdated) {
      _gigabloxFactory.recalculateWindowBlockInfo();
      for (let i = 0; i < gigaReels.length; i++) {
        const blockData = gigaReels[i].recalculateBlockData();
        if (gigaReels[i]._blockSize > 1) {
          if (Utils.isNumber(blockDataTweak[i])) {
            // there is an odd flash when the 1st pre symbol appears - this is because the clipping hasnt been done properly
            // by tweaking blockData, and passing false to updateClipRects, the 1st pre is visible
            blockData[Globals.NUM_ROWS + Globals.NUM_PRE_APPERATURE_SYMBOLS - 1] = blockDataTweak[i];
          }
          gigaReels[i].updateClipRects(false);
        }
      }
    }
  };

  gameController.paytablePopupRemoved = function () {
    // this removed comes from either player pressing same symbol
    // or the 3 second timer expiring
    if (_finalWinningsForWinCycle > resourceManager.getController('stakeController').CurrentStake) {
      if (_idleTimerPaused !== true) {
        // idle timer has been paused for a modal popup
        gameController.restartIdleTimer();
      }
    }
  };

  gameController.paytablePopupShown = function () {
    // this shown comes when a paytable popup is shown
    gameController.killShowLastWin(true);
  };

  gameController.restartIdleTimer = function () {
    console.log('IDLETIMER - restartIdleTimer');
    if (!_idleTimer && !_idleTimerPaused) {
      _idleTimer = timerManager.addTimeout(4000, () => {
        gameController.idleTimerExpired();
      });
    }
  };

  gameController.idleTimerExpired = function () {
    console.log('IDLETIMER - idleTimerExpired');
    // show last win
    _idleTimer = undefined;
    gameController.showLastWin();
    gameController.restartShowLastWinTimer();
  };

  gameController.showLastWin = function () {
    console.log('IDLETIMER - showLastWin');
    _gigabloxFactory.dimAllSymbols(true, 0.25);
    messageBox.show(true, 0.25, true);
    messageBox.setMessage('t_totalRoundWin', '');
    gameData.winningsText.setText(_finalWinningsForWinCycle);
    gameData.winningsText.show(true, 0);
    _lastWinTween = gsap.fromTo(
      gameData.winningsText,
      { alpha: 0 },
      {
        alpha: 1,
        duration: 0.25,
        ease: 'none',
      }
    );
    gameData.winningsText.pulse(1, 1.1, 0.5, 3);
  };

  gameController.restartShowLastWinTimer = function () {
    console.log('IDLETIMER - restartShowLastWinTimer');
    if (!_showLastWinTimer) {
      _showLastWinTimer = timerManager.addTimeout(2000, () => {
        gameController.showLastWinTimerExpired();
      });
    }
  };

  gameController.showLastWinTimerExpired = function () {
    console.log('IDLETIMER - idleTimerExpired');
    _showLastWinTimer = undefined;
    gameController.removeLastWin();
    gameController.restartIdleTimer();
  };

  gameController.removeLastWin = function (instant = false) {
    console.log('IDLETIMER - removeLastWin');
    _gigabloxFactory.dimAllSymbols(false, instant ? 0 : 0.25);
    messageBox.show(false, instant ? 0 : 0.25, true);
    if (instant !== true) {
      _lastWinTween = gsap.fromTo(
        gameData.winningsText,
        { alpha: 1 },
        {
          alpha: 0,
          ease: 'none',
          duration: 0.25,
          onComplete: () => {
            gameData.winningsText.stopPulsing();
            gameData.winningsText.show(false);
            gameData.winningsText.alpha = 1;
            gameData.winningsText.setScale(1);
          },
        }
      );
    } else {
      gameData.winningsText.stopPulsing();
      gameData.winningsText.show(false);
      gameData.winningsText.alpha = 1;
      gameData.winningsText.setScale(1);
    }
  };

  gameController.killShowLastWin = function () {
    console.log('IDLETIMER - killShowLastWin');
    if (_lastWinTween && _lastWinTween.isActive()) {
      _lastWinTween.progress(1);
    }
    if (_idleTimer) {
      timerManager.stop(_idleTimer);
      _idleTimer = undefined;
    }
    if (_showLastWinTimer) {
      timerManager.stop(_showLastWinTimer);
      _showLastWinTimer = undefined;
      gameController.removeLastWin(true);
    }
  };

  gameController.onModal = function (data) {
    console.log(`IDLETIMER - onModal = ${data.reason}`);
    switch (data.reason) {
      case 'goldenbetEnabled':
        _finalWinningsForWinCycle = 0;
      case 'stakeSelection':
      case 'Settings menu open':
      case 'autoplay':
      case 'buy_bonus':
        gameController.killShowLastWin(true);
        _idleTimerPaused = true;
        break;
      default:
        if (typeof data.reason === 'undefined') {
          if (_idleTimerPaused === true) {
            _idleTimerPaused = false;
            if (gameController.stateMachine.ActiveStateName === 'WAIT_FOR_START') {
              if (_finalWinningsForWinCycle > resourceManager.getController('stakeController').CurrentStake) {
                gameController.restartIdleTimer();
              }
            }
          }
        }
        break;
    }
  };

  // NEW RESTORE GOLDEN BET BEFORE RESTORE IS SHOWN
  gameController.onPreviousGameMode = (data) => {
    if (data.encore && gdk.getPlatformAllowsUpstake()) {
      const encoreButtonLB = resourceManager.get('extraButtonsContainer:luckyBetToggleButton');
      encoreButtonLB.setRecovery();
    }
  };

  gameController.onGameSkipped = function (stakeInfo) {
    // little hack, as we dont appear to setup gameData.recoveryMode like other games!!!!!!!
    if (gdk.getServerParser()._inBuyABonus) {
      gameData.recoveryMode = 'BONUS_BUY';
    }
    if (gameData.recoveryMode === 'GOLDENBET_BUY' || !gameData.recoveryMode) {
      // we dont need to worry about this for GOLDENBET or normal
    } else {
      // we make the meter show the correct stake on a restore, but nothing seems to set the stake controller up correctly if you press skip
      // so we have a new message and we do that here
      // ideally this should be in the libs somewhere!!

      const stakeController = resourceManager.getController('stakeController');

      // now we can have bonus buys on different stakes compared to normal
      // os 1st lets make sure the stake is valid for BASIC
      const stakeIndex = stakeController.Stakes.indexOf(stakeInfo.baseStake);
      if (stakeIndex === -1) {
        // the bonus buy stake isnt in the BASIC stake
        // so we need to use the default
        // this is assuming default stake has been set correctly :( as everything appears to be in closures!!
        stakeInfo.baseStake = stakeController.BaseStake;
      }

      gameData.currentStakeIndex = gameData.stakes.indexOf(stakeInfo.baseStake);

      stakeController.requestChangeStake(stakeInfo.baseStake);

      // trust me bro!
      gameData.stakeMeter.set(stakeInfo.baseStake);
    }

    // show the win meter, regardless of how much is in it
    _winMeterContainer.visible = true;
  };

  // lets have some async function to count up the winnings per cascade
  // this way we can play this at any point with out the need of a state
  gameController.showInitialWin = async function (winnings) {};
  gameController.showMultipliedWin = async function (winnings, multiplier) {};

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe('common:GameSkipped', gameController.onGameSkipped);
  messageBus.subscribe('spinner:GameConfigEvent', onGameConfigEvent);
  messageBus.subscribe('common:GameCompleteEvent', preGameComplete);
  messageBus.subscribe('autoplay:started', autoplayStarted);
  messageBus.subscribe('autoplay:ended', autoplayEnded);
  messageBus.subscribe('spinner:SpinEvent', gameController.onSpinEvent);
  messageBus.subscribe('stake:stakeChanged', gameController.onStakeChanged);
  messageBus.subscribe('spinner:WinningLinesEvent', doPayWins);
  messageBus.subscribe('tiki_runner:DropEvent', onDropEvent);
  messageBus.subscribe('tiki_runner:PopAndDropComplete', onPopAndDropComplete);
  // messageBus.subscribe("tiki_runner:RespinEvent", onRespinIntro);
  // messageBus.subscribe("tiki_runner:RespinEventDead", onRespinEvent);
  messageBus.subscribe('common:RecoverGame', recoverGame);
  messageBus.subscribe('common:JackpotGame', jackpotGame);
  messageBus.subscribe('platform:startNextGame', startGame);
  messageBus.subscribe('common:AbortGame', onAbortGame);
  messageBus.subscribe('tiki_runner:ExtraSpinsRemaining', onExtraSpinsRemaining);

  messageBus.subscribe('tiki_runner:FreeSpinsAwardEvent', onFeatureAnnounced);
  messageBus.subscribe('tiki_runner:FreeSpinsEndEvent', onFeatureEnded);

  Reflex.addToUpdate(update.bind(gameController));
  Reflex.registerEventHandler('orientationChange', gameController.onOrientationChange);

  messageBus.subscribe('common:PromotionStarted', onPromotionStarted);
  messageBus.subscribe('common:PromotionEnded', onPromotionEnded);

  messageBus.subscribe('game:modal', gameController.onModal);

  // NEW RESTORE GOLDEN BET BEFORE RESTORE IS SHOWN
  messageBus.subscribe('restore:previousGameMode', gameController.onPreviousGameMode);

  messageBus.subscribe('game:paytablePopupRemoved', gameController.paytablePopupRemoved);
  messageBus.subscribe('game:paytablePopupShown', gameController.paytablePopupShown);

  gameController.canCelebrate = true;

  console.log("GameController.switchState('WAIT_FOR_START')");
  gameController.stateMachine.switchState('WAIT_FOR_START');

  Object.seal(gameController);
  return gameController;
})();
